module.exports = {
  RoleType: {
    super: 0,
    admin: 1,
    scheduler: 2,
    follower: 3,
    streamer_admin: 4,
    follower_admin: 5,
    treasurer: 6,
    business: 7,
    buyer: 8
  },
  RoleName: {
    0: "超级管理员",
    1: "管理员",
    2: "AE",
    3: "跟播",
    4: "主播管理",
    5: "跟播管理",
    6: "财务",
    7: "商务",
    8: "采购"
  },
  StaffType: {
    短视频: 1,
    策划: 2,
    "商务统筹（品牌部）": 3,
    AE: 4,
    "商务统筹（PGC组）": 5,
    现场编导: 6,
    技术导演: 7,
    "跟播/助理": 8,
    场务: 9,
    题词: 10,
    明星接待: 11,
    视频组: 12
  },
  StaffTypeName: {
    1: "短视频",
    2: "策划",
    3: "商务统筹（品牌部）",
    4: "AE",
    5: "商务统筹（PGC组）",
    6: "现场编导",
    7: "技术导演",
    8: "跟播/助理",
    9: "场务",
    10: "题词",
    11: "明星接待",
    12: "视频组"
  },
  AnalyseFieldList: [
    {
      title: "单场分析",
      fields: [
        ["view_cnt", "观看次数"],
        ["uv", "UV"],
        ["add_fans", "新增粉丝数"],
        ["product_click_user", "商品点击人数"],
        ["order_user", "引导成交人数"],
        ["order_amount", "引导成交金额"],
        ["estimated_presale_final_amount", "预售预估总金额"],
        ["presale_front_amount", "预售定金金额"],
        ["analyse_add_fans", "每小时增粉"],
        ["analyse_product_click_user", "每小时进店率"],
        ["analyse_order_user", "引导成交率"],
        ["analyse_streamer_price", "主播单价"],
        ["analyse_streamer_total_price", "主播总价"],
        ["analyse_order_amount", "直播ROI"]
      ]
    },
    {
      title: "主播榜单",
      fields: [
        ["analyse_add_fans", "每小时增粉"],
        ["analyse_product_click_user", "每小时进店率"],
        ["analyse_order_user", "引导成交率"],
        ["analyse_order_amount", "直播ROI"]
      ]
    }
  ],
  ReportFieldList3: [
    {
      title: "小程序",
      fields: [
        ["title", "标题"],
        ["onlineUv", "实时在线人数"],
        ["watchUv", "观看人数"],
        ["watchPv", "观看次数"],
        ["averageWatchTime", "平均观看时长(秒)"],
        ["pushCnt", "累积推送次数"],
        ["clickUv", "商品点击人数"],
        ["clickPv", "商品点击次数"],
        ["likeUv", "点赞人数"],
        ["likePv", "点赞次数"],
        ["commentUv", "评论人数"],
        ["commentPv", "评论次数"],
        ["shareUv", "分享人数"],
        ["sharePv", "分享次数"],
        ["subscribeUv", "单次订阅人数"],
        ["followerNum", "累计长期订阅人数"],
        ["观看人次", "观看人次"],
        ["观看人数", "观看人数"],
        ["直播引流PV", "直播引流PV"],
        ["直播引流UV", "直播引流UV"],
        ["下单人数", "下单人数"],
        ["下单订单数", "下单订单数"],
        ["下单金额", "下单金额"],
        ["下单客单价", "下单客单价"],
        ["成交人数", "成交人数"],
        ["成交订单数", "成交订单数"],
        ["成交金额", "成交金额"],
        ["成交客单价", "成交客单价"]
      ]
    },
    {
      title: "快手后台",
      fields: [
        ["title", "标题"],
        ["实时观看人数", "实时观看人数"],
        ["平均在线人数", "平均在线人数"],
        ["离开直播间人数", "离开直播间人数"],
        ["进入直播间人数", "进入直播间人数"],
        ["上车商品数", "上车商品数"],
        ["商品下单量", "商品下单量"],
        ["商品成交件数", "商品成交件数"],
        ["商品成交金额", "商品成交金额"],
        ["商品支付人数", "商品支付人数"],
        ["讲解卡片成交件数", "讲解卡片成交件数"],
        ["讲解卡片成交占比", "讲解卡片成交占比"],
        ["讲解卡片成交订单量", "讲解卡片成交订单量"],
        ["讲解卡片成交金额", "讲解卡片成交金额"],
        ["退款金额", "退款金额"],
        ["UV价值", "UV价值"],
        ["orderGmv", "订单GMV"],
        ["人均观看时长", "人均观看时长"],
        ["单位观看时长成交金额", "单位观看时长成交金额"],
        ["客单价", "客单价"],
        ["支付转化率", "支付转化率"],
        ["曝光点击率", "曝光点击率"],
        ["次均观看时长", "次均观看时长"],
        ["直播曝光次数", "直播曝光次数"],
        ["粉丝成交占比", "粉丝成交占比"],
        ["累计成交订单量", "累计成交订单量"],
        ["累计观看人数", "累计观看人数"],
        ["退款金额", "退款金额"],
        ["投放引导下单量", "投放引导下单量"],
        ["投放引导成交金额", "投放引导成交金额"],
        ["投放引导涨粉数量", "投放引导涨粉数量"],
        ["投放引导观看次数", "投放引导观看次数"],
        ["直播期间投放ROI", "直播期间投放ROI"],
        ["直播期间投放金额", "直播期间投放金额"],
        ["川流计划引导成交支付金额", "川流计划引导成交支付金额"],
        ["川流计划引导涨粉数", "川流计划引导涨粉数"],
        ["川流计划引导观看次数", "川流计划引导观看次数"],
        ["川流计划引导订单量", "川流计划引导订单量"],
        ["川流计划曝光次数", "川流计划曝光次数"],
        ["新增粉丝数", "新增粉丝数"],
        ["粉丝复购率", "粉丝复购率"],
        ["累计买家数", "累计买家数"],
        ["累计观看人数", "累计观看人数"],
        ["上架商品数", "上架商品数"],
        ["人均观看时长", "人均观看时长"],
        ["商品点击人数", "商品点击人数"],
        ["实时在线观看人数", "实时在线观看人数"],
        ["小黄车点击数", "小黄车点击数"],
        ["成交转化率", "成交转化率"],
        ["打赏数", "打赏数"],
        ["新增粉丝数", "新增粉丝数"],
        ["点赞数", "点赞数"],
        ["粉丝平均观看时长", "粉丝平均观看时长"],
        ["累计成交人数", "累计成交人数"],
        ["累计成交订单数", "累计成交订单数"],
        ["累计成交金额", "累计成交金额"],
        ["观看人数", "观看人数"],
        ["观看次数", "观看次数"],
        ["人均观看时长", "人均观看时长"],
        ["千次观看成交金额", "千次观看成交金额"],
        ["成交订单数", "成交订单数"],
        ["成交转化率", "成交转化率"],
        ["成交金额", "成交金额"],
        ["新增粉丝数", "新增粉丝数"],
        ["累计观看人数", "累计观看人数"],
        ["累计评论数", "累计评论数"],
        ["讲解卡成交占比", "讲解卡成交占比"],
        ["讲解卡成交金额", "讲解卡成交金额"]
      ]
    },
    {
      title: "美团后台",
      fields: [
        ["title", "标题"],
        ["curOnlinePeopleNum", "当前在线人数"],
        ["exposureCount", "累计观看次数"],
        ["highestOnlinePeopleNum", "最高在线人数"],
        ["interactionRate", "观看-互动率(人数)", "%"],
        ["interactionRateWithoutShelf", "观看互动率(人数)(不含货架)", "%"],
        ["newFans", "新增粉丝数"],
        ["orderAmount", "订单成交金额", "/10000"],
        ["orderNum", "下单订单数"],
        ["orderUserCount", "下单人数"],
        ["perAvgViewTime", "人均观看时长"],
        ["perMinOnlinePeopleNum", "每分钟在线人数"],
        ["perThousandViewAmount", "千次观看成交金额", "/100"],
        ["shareUserCount", "分享人数"],
        ["skuClickRatio", "商品点击率(次数)", "%"],
        ["skuOrderRatio", "商品下单率(次数)", "%"],
        ["totalOnlinePeopleNum", "累计观看人数"],
        ["watchFollowRate", "观看-关注率(人数)", "%"],
        ["watchOrderRate", "观看-下单率(人数)", "%"]
      ]
    },
    {
      title: "新版京东后台",
      fields: [
        ["title", "标题"],
        ["onlineUv", "当前在线人数"],
        ["dealAmt", "累计成交金额"],
        ["dealSaleQtty", "成交件数"],
        ["dealParent", "成交父单量"],
        ["dealSaleRate", "成交转化率"],
        ["uvValue", "UV价值"],
        ["uv", "访问人数"],
        ["pv", "访问人次"],
        ["clickExposureRate", "曝光点击率"],
        ["quotationRate", "引商率"],
        ["stayTime", "人均停留时长"],
        ["newFans", "新增粉丝数"],
        ["commentPv", "评论次数"],
        ["likePv", "点赞次数"],
        ["sharePv", "分享次数"],
        ["fanVisits", "粉丝访问占比"],
        ["fanTransactions", "粉丝成交占比"],
        ["dealSaleUv", "成交人数"],
        ["gpm", "GPM"],
        ["quotationUv", "引商人数"],
        ["dealChild", "成交子单量"],
        ["depositUserSum", "定金人数"],
        ["depositAmtSum", "定金金额"],
        ["finalAmtSum", "预估尾款金额"],
        ["ordQttySum", "定金件数"]
      ]
    }
  ],
  ReportFieldList2: [
    {
      title: "抖音后台",
      fields: [
        ["title", "标题"],
        // 直播大屏core_data
        ["dy_online_user_cnt", "平均在线人数"],
        ["dy_live_show_watch_cnt_ratio", "曝光-观看率(次数)", "%"],
        ["dy_watch_interact_ucnt_ratio", "观看-互动率(人数)", "%"],
        ["dy_follow_anchor_ucnt", "新增粉丝数"],
        ["dy_watch_ucnt", "累计观看人数"],
        ["dy_live_show_cnt", "曝光次数"],
        ["dy_avg_watch_duration", "人均观看时长(秒)"],
        ["dy_avg_min_comment_cnt", "平均评论次数(分钟)"],
        ["dy_watch_follow_ucnt_ratio", "观看-关注率(人数)", "%"],
        ["dy_fans_club_join_ucnt", "新加直播团人数"],
        ["dy_watch_fans_club_join_ucnt_ratio", "观看-加直播团率(人数)", "%"],
        ["dy_incr_ecf_club_ucnt", "新加购物团人数"],
        ["dy_incr_ecf_club_ucnt_ratio", "观看-加购物团率(人数)", "%"],
        ["dy_pay_ucnt", "成交人数"],
        ["dy_gpm", "千次观看成交金额", "/100"],
        ["dy_watch_pay_ucnt_ratio", "观看-成交率(人数)", "%"],
        ["dy_product_click_pay_ucnt_ratio", "商品点击-成交率(人数)", "%"],
        ["dy_real_refund_amt", "退款金额", "/100"],
        ["dy_real_refund_amt_ratio", "退款金额占比"],
        ["dy_pay_deposit_pre_order_amt", "预售全款金额", "/100"],
        ["dy_pay_combo_cnt", "成交件数"],
        ["dy_old_fans_pay_ucnt_ratio", "成交老粉占比"],
        ["dy_stat_cost", "千川消耗", "/100"],
        ["dy_livetoind_pay_amt", "指示器成交金额", "/100"],
        ["dy_punish_cnt", "违规次数"],

        // 这里字段名字还需要再确认一下
        // 巨量千川
        ["dy_totalLiveAcu", "平均在线人数"],
        ["dy_totalLivePayOrderGmv", "累计成交金额(元)", "/100000"],
        ["dy_totalLivePayOrderGpmEcom", "GPM"],
        ["dy_watchPayUcntRatio", "观看-成交转化率", "%1"],
        ["dy_totalLiveDurationAvgEcom", "平均停留时长(秒)", "f2"],
        ["dy_adLivePayOrderGmvRoi", "广告ROI"],
        ["dy_adLivePayOrderRate", "广告支付转化率", "%1"],
        ["dy_ctr", "广告点击率", "%1"],
        ["dy_liveOrderPayCouponAmount", "成交智能优惠券金额(元)", "/10000"],
        ["dy_livePayOrderGmvRoi", "整体ROI", "f2"],
        ["dy_lubanLivePayOrderGmv", "广告成交金额", "/10000"],
        ["dy_lubanLivePayOrderGpm", "广告GPM", "/100000"],
        ["dy_statCost", "广告消耗", "/10000"],

        ["dy_traffic_source_from_pay", "流量来源-付费流量", "%1"],
        ["dy_traffic_invert_ad_cvr", "流量转化-广告CVR", "%1"],
        ["dy_traffic_invert_nature_cvr", "流量转化-自然流CVR", "%1"],

        // 直播间详情
        ["dy_baoguang_number", "直播间曝光人数", "int"],
        ["dy_max_online_number", "最高在线人数"],
        ["dy_dianzan_count", "点赞次数"],
        ["dy_comment_count", "评论次数"],
        ["dy_goods_click_count", "商品点击人数"],
        ["dy_live_goods_click_rate", "直播间商品曝光-点击率(人数)", "%1"],
        ["dy_price_per_customer", "客单价"]
      ]
    }
  ],
  ReportFieldList: [
    {
      title: "中控台数据",
      fields: [
        ["tb_live_id", "淘宝直播ID"],
        ["title", "标题"],
        ["view_cnt", "浏览次数"],
        ["start_viewer", "在线人数(开)"],
        ["end_viewer", "在线人数(下)"],
        ["max_viewer", "在线人数(最高)"],
        ["avg_view_time", "平均观看时长(秒)"],
        ["title_page_ctr", "封面图点击率"],
        ["pv", "观看次数（PV）"],
        ["uv", "观看人数（UV）"],
        ["extra_view_cnt", "额外奖励流量"],
        ["add_fans", "新增粉丝数"],
        ["product_click_user", "商品点击人数"],
        ["product_click", "商品点击次数"],
        ["product_ctr", "商品点击率"],
        ["order_user", "引导成交人数"],
        ["order_amount", "引导成交金额"],
        ["order_product_num", "引导成交件数"],
        ["estimated_presale_final_amount", "预售预估总金额"],
        ["order_rate", "引导成交转化率"],
        ["presale_front_amount", "预售定金金额"],
        ["live_flow_score_level", "实时流量竞争力评级"],
        ["trd_score", "实时推荐流量交易指数"],
        ["popularity_score", "实时推荐流量内容指数"],
        ["top_product", "点击率前三商品"]
      ]
    },
    {
      title: "京东后台",
      fields: [
        ["title", "标题"],
        ["jd_deal_total", "成交金额"],
        ["jd_sales_total", "成交件数"],
        ["jd_deal_sale_rate", "成交转化率"],
        ["jd_click_exposure_rate", "曝光点击率"],
        ["jd_follow_num", "新增粉丝数"],
        ["jd_uv", "访问人数"],
        ["jd_pv", "访问人次"],
        ["jd_stay_time", "人均停留时长"],
        ["jd_thumb_num", "点赞数"],
        ["jd_comment_num", "评论数"],
        ["top_product", "点击率前三商品"]
      ]
    },
    {
      title: "抖音后台",
      fields: [
        ["title", "标题"],
        ["dy_online_user_cnt", "观看人数"],
        ["dy_watch_uv", "观看次数"],
        ["dy_max_viewer", "最高在线人数"],
        ["dy_pay_cnt", "成交人数"],
        ["dy_incr_fans_cnt", "新增粉丝数"],
        ["dy_comment_num", "点赞数"],
        ["dy_comment_num", "评论数"],
        ["dy_show_uv", "商品曝光"],
        ["dy_click_uv", "点击人数"],
        ["dy_pay_in_live_num", "订单数"],
        ["dy_pay_in_live_gmv", "GMV销售额"],
        ["dy_cost", "投放金额"],
        ["dy_convert_distribution", "投放流量"],
        ["dy_luban_live_pay_order_gmv", "投放转化金额"],
        // 以下是旧版本数据
        ["dy_accumulative_watch_times", "直播间观看人次（旧版数据）"],
        ["dy_created_order_num", "创建订单数（旧版数据）"],
        ["dy_created_gmv", "创建订单金额（旧版数据）"],
        ["dy_pay_order_num", "成交订单数（旧版数据）"],
        ["dy_pay_gmv", "成交金额（旧版数据）"],
        ["dy_order_pay_ratio", "订单付款率（旧版数据）"]
      ]
    },
    {
      title: "生意参谋",
      fields: [
        ["shop_uv", "引导进店UV"],
        ["shop_fans_uv", "引导粉丝进店UV"],
        ["shop_order_cnt", "转化笔数"],
        ["shop_fans_order_cnt", "粉丝转化笔数"],
        ["shop_order_amount", "转化金额"],
        ["shop_fans_order_amount", "粉丝转化金额"]
      ]
    },
    {
      title: "存档",
      fields: [
        ["replay_url", "直播视频回放"],
        ["follower_remark_info", "跟播备注"],
        ["tb_live_screen_shot", "中控台截图"],
        ["streamer_screen_shot", "讲解主播截图"],
        ["product_click_screen_shot", "商品点击截图"],
        ["billboard_screen_shot", "榜单截图"]
      ]
    },
    {
      title: "运营备注",
      fields: [
        ["live_activity", "店铺活动"],
        ["live_resource", "资源位"],
        ["live_activity_remark", "活动备注"],
        ["live_summary", "直播总结"]
      ]
    }
  ],
  // 弃用，旧版本类型
  CompanyStaffType: {
    "1": "短视频",
    "2": "文案策划",
    "3": "商务",
    "4": "AE"
  },
  CompanyAccountingType: {
    "1": "费用项",
    "2": "费用(报价)项"
  },
  BrandType: {
    "1": "淘宝直播",
    "2": "京东直播",
    "3": "抖音直播",
    "4": "PGC",
    "6": "快手直播",
    "5": "小程序",
    "7": "美团直播",
    "8": "京东直播"
  },
  PGCBandType: {
    "1": "淘宝直播",
    "2": "京东直播",
    "3": "抖音直播",
    "4": "小程序"
  },
  PGCStudioType: {
    "1": "公司",
    "2": "外场"
  },
  SupplierStatusOptions: [
    {
      label: "正常",
      value: 0
    },
    {
      label: "停用",
      value: 1
    },
    {
      label: "待审核",
      value: 2
    }
  ],
  SupplierServiceOptions: [
    {
      label: "设计类",
      value: "设计类"
    },
    {
      label: "制作团队",
      value: "制作团队"
    },
    {
      label: "策划",
      value: "策划"
    },
    {
      label: "图文",
      value: "图文"
    },
    {
      label: "短视频",
      value: "短视频"
    },
    {
      label: "直播影棚",
      value: "直播影棚"
    },
    {
      label: "场景搭建",
      value: "场景搭建"
    },
    {
      label: "明星经纪",
      value: "明星经纪"
    },
    {
      label: "红人经纪",
      value: "红人经纪"
    },
    {
      label: "妆发造型",
      value: "妆发造型"
    },
    {
      label: "明星商务茶歇采买对接",
      value: "明星商务茶歇采买对接"
    }
  ],
  SupplierOfferType: {
    场地: 1,
    摄制人员: 2,
    摄制器材: 3,
    内容: 4,
    置景: 5,
    差旅: 6,
    嘉宾模特等人员: 7
  },
  ProjectStatusOptions: [
    {
      label: "报价中（未审核）",
      value: 0
    },
    {
      label: "报价中（采购已审核，财务未审核）",
      value: 1
    },
    {
      label: "报价中（财务已审核，采购未审核）",
      value: 2
    },
    {
      label: "报价中（已审核）",
      value: 3
    },
    {
      label: "进行中",
      value: 4
    },
    {
      label: "已结束（品牌未结算）",
      value: 5
    },
    {
      label: "已结束（品牌已结算）",
      value: 6
    },
    {
      label: "已完成",
      value: 7
    },
    {
      label: "已取消（待审核）",
      value: 8
    },
    {
      label: "已取消",
      value: 9
    }
  ],
  ProjectStatusName: {
    0: "报价中（未审核）",
    1: "报价中（采购已审核，财务未审核）",
    2: "报价中（财务已审核，采购未审核）",
    3: "报价中（已审核）",
    4: "进行中",
    5: "已结束（品牌未结算）",
    6: "已结束（品牌已结算）",
    7: "已完成",
    8: "已取消（待审核）",
    9: "已取消"
  },
  ProjectTypeOptions: [
    {
      label: "单机位（Ｓ）",
      value: 1
    },
    {
      label: "双机位（Ｄ）",
      value: 2
    },
    {
      label: "明星（Ａ）",
      value: 3
    }
  ],
  ProjectTypeMap: {
    0: "未知",
    1: "单机位（Ｓ）",
    2: "双机位（Ｄ）",
    3: "明星（Ａ）"
  },
  ProjectCoTypeOptions: [
    {
      label: "年框",
      value: 0
    },
    {
      label: "非年框",
      value: 1
    },
    {
      label: "自定义",
      value: 2
    }
  ],
  ProjectCoTypeMap: {
    0: "年框",
    1: "非年框",
    2: "自定义"
  },
  ProjectCostItemTypeOptions: [
    {
      label: "摄制人员",
      value: 101
    },
    {
      label: "供应商成本",
      value: 102
    },
    {
      label: "内容",
      value: 103
    },
    {
      label: "杂费",
      value: 104
    }
  ],
  ProjectCostItemTypeMap: {
    101: "摄制人员",
    102: "供应商成本",
    103: "内容",
    104: "杂费"
  },
  ProjectItemTypeOptions: [
    {
      label: "场地",
      value: 1
    },
    {
      label: "摄制人员",
      value: 2
    },
    {
      label: "摄制器材",
      value: 3
    },
    {
      label: "内容",
      value: 4
    },
    {
      label: "置景",
      value: 5
    },
    {
      label: "差旅",
      value: 6
    },
    {
      label: "嘉宾模特等人员",
      value: 7
    }
  ],
  ProjectItemTypeMap: {
    1: "场地",
    2: "摄制人员",
    3: "摄制器材",
    4: "内容",
    5: "置景",
    6: "差旅",
    7: "嘉宾模特等人员"
  },
  ProjectCustomItemStatusMap: {
    0: "未审核",
    1: "采购已审核，财务未审核",
    2: "财务已审核，采购未审核",
    3: "已审核"
  },
  ProjectItemKOLTypeOptions: [
    {
      label: "明星",
      value: 0
    },
    {
      label: "总裁",
      value: 1
    },
    {
      label: "非明星",
      value: 2
    }
  ],
  // 供应商套餐
  SupplierOfferSetType: {
    不选套餐: 0,
    S: 1,
    A: 2,
    B: 3,
    O: 4
  },
  // 场地+供应商模式对应套餐
  SupplierOfferSetSITMap: {
    SIT00102: { 不选套餐: 0, A: 2, B: 3 },
    SIT00201: { 不选套餐: 0, S: 1, A: 2, O: 4 },
    SIT00202: { 不选套餐: 0, S: 1, O: 4 },
    SIT00301: { 不选套餐: 0, O: 4 },
    SIT00302: { 不选套餐: 0, O: 4 }
  },
  // 审核过后还可以编辑的项目
  SupplierOfferEditFree: ["SET00201", "SET00301", "TRA00101", "TRA00102"],
  // 不可编辑成本的项目
  SupplierOfferUneditableCost: [
    "SIT00102",
    "SIT00201",
    "CRE00101",
    "CRE00102",
    "CRE00103",
    "CRE00201",
    "CRE00202",
    "CRE00203",
    "CRE00302",
    "EQU00203",
    "EQU00401",
    "EQU00502",
    "EQU00603",
    "EQU00702",
    "CON00101",
    "CON00102",
    "CON00103",
    "CON00104",
    "CON00105",
    "CON00106",
    "CON00201",
    "CON00202",
    "CON00203",
    "CON00204",
    "SET00101",
    "CAS00102"
  ],
  // 包含供应商选项的项目
  SupplierOfferNeedSupplier: [
    "CRE003",
    "CRE004",
    "CRE005",
    "CRE006",
    "CRE007",
    "EQU001",
    "EQU002",
    "EQU003",
    "EQU004",
    "EQU005",
    "EQU006",
    "EQU007",
    "EQU008",
    "EQU009",
    "EQU010",
    "EQU010"
  ],
  // 和机位关联的项目
  SupplierOfferDefaultNum: [
    "CRE00401",
    "CRE00402",
    "CRE00403",
    "EQU00201",
    "EQU00203"
  ],
  // 可重复选择工作人员类型
  SupplierOfferStaffMultiSelect: [
    "CON00101",
    "CON00102",
    "CON00103",
    "CON00104",
    "CON00105",
    "CON00106",
    "CON00201",
    "CON00202",
    "CON00203",
    "CON00204"
  ],
  // 可添加工作人员类型
  SupplierOfferStaffTypeMap: {
    CRE00101: [],
    CRE00102: [5],
    CRE00103: [5],
    CRE00201: [2, 4],
    CRE00202: [2],
    CRE00203: [4],
    CRE00302: [1, 7],
    CRE00502: [1, 7],
    CRE00602: [1, 7],
    CRE00403: [1, 4, 8],
    CRE00702: [4, 8],
    CRE00801: [8],
    CRE00901: [],
    CRE01001: [9],
    CRE01101: [10],
    CRE01201: [11],
    CRE01301: [12],
    CON00101: [2],
    CON00102: [2],
    CON00103: [2],
    CON00104: [2],
    CON00105: [2],
    CON00106: [2],
    CON00201: [2],
    CON00202: [2],
    CON00203: [2],
    CON00204: [2]
  },
  SupplierOfferStaffTypeSpecialMap: {
    CRE00101: [],
    CRE00102: [3, 5],
    CRE00103: [3, 5],
    CRE00201: [2, 4],
    CRE00202: [2],
    CRE00203: [4],
    CRE00302: [1, 7],
    CRE00502: [1, 7],
    CRE00602: [1, 7],
    CRE00403: [1, 4, 8],
    CRE00702: [4, 8],
    CRE00801: [8],
    CRE00901: [],
    CRE01001: [9],
    CRE01101: [10],
    CRE01201: [11],
    CRE01301: [12],
    CON00101: [2],
    CON00102: [2],
    CON00103: [2],
    CON00104: [2],
    CON00105: [2],
    CON00106: [2],
    CON00201: [2],
    CON00202: [2],
    CON00203: [2],
    CON00204: [2]
  },
  // 次级选项
  // multi 表示比如 CRE001 的多个选项可以多选
  // multiple 表示比如 CRE001 的选项中的每一项可以选多次
  SupplierOfferSubList: {
    2: [
      { label: "项目统筹", key: "CRE001", multi: false, multiple: false },
      { label: "现场导播", key: "CRE002", multi: false, multiple: false },
      { label: "技术导演", key: "CRE003", multi: false, multiple: false },
      { label: "摄像师", key: "CRE004", multi: true, multiple: true },
      { label: "灯光师", key: "CRE005", multi: true, multiple: true },
      { label: "调音师", key: "CRE006", multi: true, multiple: true },
      { label: "推流师", key: "CRE007", multi: true, multiple: true },
      { label: "中控", key: "CRE008", multi: true, multiple: true },
      { label: "网络技术工程师", key: "CRE009", multi: true, multiple: true },
      { label: "场务", key: "CRE010", multi: true, multiple: true },
      { label: "题词", key: "CRE011", multi: true, multiple: true },
      { label: "明星接待", key: "CRE012", multi: true, multiple: true },
      { label: "视频组", key: "CRE013", multi: true, multiple: true }
    ],
    3: [
      { label: "导播台", key: "EQU001", multi: false, multiple: false },
      { label: "摄像设备", key: "EQU002", multi: false, multiple: false },
      { label: "辅助摄像", key: "EQU003", multi: true, multiple: false },
      { label: "视频采集", key: "EQU004", multi: true, multiple: false },
      { label: "灯光设备组", key: "EQU005", multi: false, multiple: false },
      { label: "收音设备", key: "EQU006", multi: true, multiple: false },
      { label: "推流设备", key: "EQU007", multi: false, multiple: false },
      { label: "输出设备", key: "EQU008", multi: true, multiple: false },
      { label: "达芬奇调色", key: "EQU009", multi: true, multiple: false },
      { label: "网络设备", key: "EQU010", multi: true, multiple: false }
    ],
    4: [
      { label: "内容策划", key: "CON001", multi: true, multiple: false },
      { label: "素材制作", key: "CON002", multi: true, multiple: false }
    ],
    5: [
      { label: "直播背景", key: "SET001", multi: true, multiple: false },
      { label: "背景道具运输", key: "SET002", multi: true, multiple: false },
      { label: "其他增项费用", key: "SET003", multi: true, multiple: false }
    ],
    6: [
      { label: "员工/嘉宾差旅", key: "TRA001", multi: true, multiple: false }
    ],
    7: [{ label: "嘉宾/模特", key: "CAS001", multi: true, multiple: false }]
  },
  mockProject: {
    code: 0,
    data: {
      pgc_studios: [
        {
          location: "",
          name: "\u4e9a\u7ec6\u4e9a",
          cost: 5000.0,
          total_project_cnt: 19,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 1
        },
        {
          location: "",
          name: "\u65e5\u64ad\u76f4\u64ad\u95f4",
          cost: 0,
          total_project_cnt: 312,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 2
        },
        {
          location: "",
          name: "\u5929\u6d25\u76f4\u64ad\u95f4\uff08\u975e\u5916\u573a\uff09",
          cost: 4000.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 3
        },
        {
          location: "",
          name: "\u5317\u4eac\u76f4\u64ad\u95f4\uff08\u975e\u5916\u573a\uff09",
          cost: 4000.0,
          total_project_cnt: 5,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 4
        },
        {
          location: "",
          name: "\u91cd\u5e86\u76f4\u64ad\u95f4\uff08\u975e\u5916\u573a\uff09",
          cost: 4000.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 5
        },
        {
          location: "",
          name: "\u4e0a\u6d77\u76f4\u64ad\u95f4\uff08\u975e\u5916\u573a\uff09",
          cost: 4000.0,
          total_project_cnt: 19,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 6
        },
        {
          location: "",
          name: "\u6cf0\u5c71",
          cost: 4000.0,
          total_project_cnt: 3,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 7
        },
        {
          location: "",
          name: "\u6052\u5c71",
          cost: 4000.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 8
        },
        {
          location: "",
          name: "\u5927\u6d0b\u6d32",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 9
        },
        {
          location: "",
          name: "\u5357\u6781\u6d32",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 10
        },
        {
          location: "",
          name: "\u5317\u7f8e\u6d32",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 11
        },
        {
          location: "",
          name: "\u5357\u7f8e\u6d32",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 12
        },
        {
          location: "",
          name: "\u975e\u6d32",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 13
        },
        {
          location: "",
          name: "\u5317\u51b0\u6d0b",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 14
        },
        {
          location: "",
          name: "\u592a\u5e73\u6d0b",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 16
        },
        {
          location: "",
          name: "\u5927\u897f\u6d0b",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 17
        },
        {
          location: "",
          name: "\u5357\u51b0\u6d0b",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 18
        },
        {
          location: "",
          name: "\u5370\u5ea6\u6d0b",
          cost: 4500.0,
          total_project_cnt: 1,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 19
        },
        {
          location: "",
          name: "\u534e\u5c71",
          cost: 4500.0,
          total_project_cnt: 3,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 20
        },
        {
          location: "",
          name: "\u6b27\u7f57\u5df4",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 21
        },
        {
          location: "",
          name: "\u6606\u4ed1\u5c71",
          cost: 4500.0,
          total_project_cnt: 17,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 22
        },
        {
          location: "",
          name: "\u5b89\u7b2c\u65af\u5c71",
          cost: 4500.0,
          total_project_cnt: 33,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 23
        },
        {
          location: "",
          name: "\u963f\u5c14\u5351\u65af\u5c71",
          cost: 4500.0,
          total_project_cnt: 0,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 24
        },
        {
          location: "",
          name: "\u843d\u57fa\u5c71",
          cost: 4500.0,
          total_project_cnt: 8,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 25
        },
        {
          location: "",
          name: "\u559c\u9a6c\u62c9\u96c5",
          cost: 4500.0,
          total_project_cnt: 3,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 26
        },
        {
          location: "",
          name: "\u5929\u5c71",
          cost: 5000.0,
          total_project_cnt: 36,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 27
        },
        {
          location: "",
          name: "\u73e0\u7a46\u6717\u739b",
          cost: 5000.0,
          total_project_cnt: 99,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 28
        },
        {
          location: "\u4e0a\u6d77",
          name: "\u4e0a\u6d77\u5916\u573a",
          cost: 0,
          total_project_cnt: 384,
          staff_limit: "5",
          travel_cost_limit: 200.0,
          type: 2,
          pgc_studio_id: 29
        },
        {
          location: "\u5317\u4eac",
          name: "\u5317\u4eac\u5916\u573a",
          cost: 0,
          total_project_cnt: 101,
          staff_limit: "10",
          travel_cost_limit: 3000.0,
          type: 2,
          pgc_studio_id: 30
        },
        {
          location: "\u6a2a\u5e97",
          name: "\u6a2a\u5e97\u5916\u573a",
          cost: 0,
          total_project_cnt: 33,
          staff_limit: "10",
          travel_cost_limit: 1000.0,
          type: 2,
          pgc_studio_id: 31
        },
        {
          location: "\u676d\u5dde",
          name: "\u676d\u5dde\u5916\u573a",
          cost: 0,
          total_project_cnt: 97,
          staff_limit: "10",
          travel_cost_limit: 1500.0,
          type: 2,
          pgc_studio_id: 32
        },
        {
          location: "\u6d77\u53e3",
          name: "\u6d77\u53e3\u5916\u573a",
          cost: 0,
          total_project_cnt: 5,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 33
        },
        {
          location: "\u5e7f\u5dde",
          name: "\u5e7f\u5dde\u5916\u573a",
          cost: 0,
          total_project_cnt: 37,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 34
        },
        {
          location: "\u4e09\u4e9a",
          name: "\u4e09\u4e9a\u5916\u573a",
          cost: 0,
          total_project_cnt: 12,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 36
        },
        {
          location: "\u6b66\u6c49",
          name: "\u6b66\u6c49\u5916\u573a",
          cost: 0,
          total_project_cnt: 5,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 37
        },
        {
          location: "\u6210\u90fd",
          name: "\u6210\u90fd\u5916\u573a",
          cost: 0,
          total_project_cnt: 15,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 38
        },
        {
          location: "\u8c61\u5c71",
          name: "\u8c61\u5c71\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 39
        },
        {
          location: "\u82cf\u5dde",
          name: "\u82cf\u5dde\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 40
        },
        {
          location: "\u963f\u90a3\u4e9a",
          name: "\u963f\u90a3\u4e9a\u5916\u573a",
          cost: 0,
          total_project_cnt: 4,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 41
        },
        {
          location: "\u5357\u4eac",
          name: "\u5357\u4eac\u5916\u573a",
          cost: 0,
          total_project_cnt: 9,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 42
        },
        {
          location: "\u6cb3\u5357",
          name: "\u6cb3\u5357\u5916\u573a",
          cost: 0,
          total_project_cnt: 3,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 43
        },
        {
          location: "",
          name: "\u7406\u80a4\u6cc9\u7279\u6b8a",
          cost: 1137.5,
          total_project_cnt: 4,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 44
        },
        {
          location: "\u65b0\u52a0\u5761",
          name: "\u65b0\u52a0\u5761\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 45
        },
        {
          location: "\u5f90\u6c47\u6ee8\u6c5f\u963f\u91cc",
          name: "\u963f\u91cc\u5916\u573a",
          cost: 0,
          total_project_cnt: 4,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 46
        },
        {
          location: "\u957f\u6c99",
          name: "\u957f\u6c99\u5916\u573a",
          cost: 0,
          total_project_cnt: 12,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 47
        },
        {
          location: "",
          name: "\u6606\u5c71\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 48
        },
        {
          location: "",
          name:
            "\u676d\u5dde\u8288\u58f3\u76f4\u64ad\u95f4\uff08\u975e\u5916\u573a\uff09",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 1,
          pgc_studio_id: 49
        },
        {
          location: "\u91cd\u5e86",
          name: "\u91cd\u5e86\u5916\u573a",
          cost: 0,
          total_project_cnt: 3,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 50
        },
        {
          location: "\u6cd5\u56fd\u5df4\u9ece",
          name: "\u5df4\u9ece\u5916\u573a",
          cost: 0,
          total_project_cnt: 48,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 51
        },
        {
          location: "\u6e56\u5317\u8346\u5dde",
          name: "\u8346\u5dde\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 53
        },
        {
          location: "\u6842\u6797",
          name: "\u6842\u6797\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 54
        },
        {
          location: "\u666f\u5fb7\u9547",
          name: "\u666f\u5fb7\u9547\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 55
        },
        {
          location: "\u53a6\u95e8",
          name: "\u53a6\u95e8\u5916\u573a",
          cost: 0,
          total_project_cnt: 3,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 56
        },
        {
          location: "\u5b81\u6ce2",
          name: "\u5b81\u6ce2\u5916\u573a",
          cost: 0,
          total_project_cnt: 9,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 57
        },
        {
          location: "\u6df1\u5733",
          name: "\u6df1\u5733\u5916\u573a",
          cost: 0,
          total_project_cnt: 11,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 58
        },
        {
          location: "\u5df4\u5398\u5c9b",
          name: "\u5df4\u5398\u5c9b\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 59
        },
        {
          location: "\u65e5\u5185\u74e6",
          name: "\u65e5\u5185\u74e6\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 60
        },
        {
          location: "\u65e0\u9521",
          name: "\u65e0\u9521\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 61
        },
        {
          location: "\u963f\u52d2\u6cf0",
          name: "\u963f\u52d2\u6cf0\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 62
        },
        {
          location: "\u5a01\u6d77",
          name: "\u5a01\u6d77\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 63
        },
        {
          location: "\u5357\u901a",
          name: "\u5357\u901a\u5916\u573a",
          cost: 0,
          total_project_cnt: 0,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 64
        },
        {
          location: "\u798f\u5dde\u5916\u573a",
          name: "\u798f\u5dde\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 65
        },
        {
          location: "",
          name: "\u897f\u5b89\u5916\u573a",
          cost: 0,
          total_project_cnt: 4,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 66
        },
        {
          location: "\u8fea\u62dc",
          name: "\u8fea\u62dc\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 67
        },
        {
          location: "\u6cc9\u5dde\u5916\u573a",
          name: "\u6cc9\u5dde\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: "0",
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 68
        },
        {
          location: "\u5f20\u5bb6\u754c",
          name: "\u5f20\u5bb6\u754c\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 69
        },
        {
          location: "\u97e9\u56fd",
          name: "\u97e9\u56fd\u5916\u573a",
          cost: 0,
          total_project_cnt: 2,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 70
        },
        {
          location: "\u6566\u714c",
          name: "\u6566\u714c\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 71
        },
        {
          location: "\u8944\u9633",
          name: "\u8944\u9633\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 72
        },
        {
          location: "\u5e7f\u897f",
          name: "\u5e7f\u897f\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 75
        },
        {
          location: "\u6fb3\u95e8",
          name: "\u6fb3\u95e8\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 76
        },
        {
          location: "\u4e49\u4e4c",
          name: "\u4e49\u4e4c\u5916\u573a",
          cost: 0,
          total_project_cnt: 1,
          staff_limit: 0,
          travel_cost_limit: 0,
          type: 2,
          pgc_studio_id: 77
        }
      ],
      items: [
        {
          ae_earn: 3066.0,
          location: "",
          creater_id: 206,
          ae: {
            name: "\u9a6c\u8389",
            staff_id: 552
          },
          pgc_brand_id: 21,
          pgc_studio_id: 29,
          business_earn: 3066.0,
          status: 6,
          creater_email: "xuxh@miicore.com",
          project_type: 2,
          start_time: "2025-04-30 00:00:00",
          project_id: 1633,
          code: "ssit001012025043002",
          creater_name: "\u5f90\u6653\u6db5",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 0,
          kols: ["\u827a\u4eba\u5468\u8fb9"],
          items: [
            {
              type: 1,
              buy_real_price: 2000.0,
              extend: "1",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29873,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "10\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00101",
                content: "\u58a8\u81e3\u6807\u51c6\u76f4\u64ad\u95f4",
                type: 1,
                extend_type: 1,
                purchase_price: 2000.0,
                offer_id: 17
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 306600.0,
              description: "\u5c0f\u5361 \u5361\u518c \u900f\u5361 ",
              num: "1",
              invoice_status: 0,
              item_id: 29874,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u9053\u5177\u6837\u54c1\u7b49",
                sku_code: "SET00301",
                content: "\u5176\u4ed6\u589e\u9879\u8d39\u7528",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 27
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 12040.39,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "465",
              real_pay: 12040.39,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29872
            },
            {
              buy_real_price: 200.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "\u9898\u8bcd",
                spec: "\u9898\u8bcd",
                num: "1",
                year_price: 500.0,
                non_year_price: 500.0,
                sku_code: "CRE01101",
                content: "\u9898\u8bcd",
                extend_type: 2,
                purchase_price: 100.0,
                offer_id: 137
              },
              type: 101,
              extend: "163",
              real_pay: 200.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30314
            },
            {
              buy_real_price: 200.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u9053\u5177\u9648\u5217 \u6837\u54c1\u6446\u653e\uff08PGC\u7ec4AE/\u54c1\u724cAE\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 2000.0,
                sku_code: "CRE01001",
                content: "\u573a\u52a1",
                extend_type: 2,
                purchase_price: 200.0,
                offer_id: 57
              },
              type: 101,
              extend: "296",
              real_pay: 200.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30315
            },
            {
              buy_real_price: 500.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u8282\u76ee\u5f69\u6392/\u5185\u5bb9\u5f69\u6392/\u73b0\u573a\u7f16\u5bfc\uff08\u7b56\u5212\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 3000.0,
                sku_code: "CRE00202",
                content: "\u73b0\u573a\u5bfc\u64ad-A\u7ea7",
                extend_type: 2,
                purchase_price: 300.0,
                offer_id: 48
              },
              type: 101,
              extend: "37",
              real_pay: 500.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30317
            },
            {
              buy_real_price: 123485.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {},
              type: 102,
              extend: "1,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30368
            },
            {
              buy_real_price: 2000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 4,
                name: "",
                spec: "",
                num: "1",
                year_price: 5000.0,
                non_year_price: 5000.0,
                sku_code: "CON00104",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              type: 103,
              extend: "37",
              real_pay: 1000.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30316
            },
            {
              buy_real_price: 56745.12,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u5149\u5f71\u5c0f\u536114924.38+\u5361\u518cpp\u888b4590.62+\u5c0f\u5361pp\u888b6359.97+\u6d3b\u987543.9+\u95ea\u9001\u8d27\u62c9\u62c9559.66+\u5361\u518c\u5185\u987521764.26+\u4e9a\u514b\u529bpp\u888b95.3+\u5361\u518c61.8+\u8d3a\u5361\u91d1\u8272\u7b7e\u5b57\u7b1465.6+\u987a\u4e307064.98+\u4e9a\u514b\u529b\u7b7e\u540d\u71671214.75",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30495
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "2025-07-15",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-28",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-14",
          review_status: 1,
          gr_files: [
            {
              name: "\u7ea2\u8170\u5b50\u827a\u4eba\u5468\u8fb9250424.pptx",
              uid: 1747215211797,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_ssit001012025043002_1747215185218..pptx"
            }
          ],
          invoice_time: "",
          name:
            "20250430\u8d44\u751f\u5802\u5929\u732b\u827a\u4eba\u5468\u8fb9PGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 0.0,
          location: "",
          creater_id: 356,
          ae: {
            name: "\u5b89\u601d\u540d",
            staff_id: 479
          },
          pgc_brand_id: 208,
          pgc_studio_id: 32,
          business_earn: 0.0,
          status: 6,
          creater_email: "siming@miicore.com",
          project_type: 3,
          start_time: "2025-04-30 00:00:00",
          project_id: 1632,
          code: "asit003012025043001",
          creater_name: "\u5b89\u601d\u540d",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 0,
          kols: ["\u9a6c\u67cf\u5168"],
          items: [
            {
              type: 1,
              buy_real_price: 30000.0,
              extend: "2:14,",
              buy_real_charge: 166541.08,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29863,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 35000.0,
                year_price: 32000.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00301",
                content: "\u9152\u5e97\u7b49\u5176\u4ed6\u5916\u68da",
                type: 1,
                extend_type: 1,
                purchase_price: 30000.0,
                offer_id: 21
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 1860.31,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "482",
              real_pay: 1860.31,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29862
            },
            {
              buy_real_price: 500.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u8282\u76ee\u5f69\u6392/\u5185\u5bb9\u5f69\u6392/\u73b0\u573a\u7f16\u5bfc\uff08\u7b56\u5212\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 3000.0,
                sku_code: "CRE00202",
                content: "\u73b0\u573a\u5bfc\u64ad-A\u7ea7",
                extend_type: 2,
                purchase_price: 300.0,
                offer_id: 48
              },
              type: 101,
              extend: "600",
              real_pay: 500.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29964
            },
            {
              buy_real_price: 300.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "\u9898\u8bcd",
                spec: "\u9898\u8bcd",
                num: "1",
                year_price: 500.0,
                non_year_price: 500.0,
                sku_code: "CRE01101",
                content: "\u9898\u8bcd",
                extend_type: 2,
                purchase_price: 100.0,
                offer_id: 137
              },
              type: 101,
              extend: "170",
              real_pay: 300.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29965
            },
            {
              buy_real_price: 300.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u660e\u661f\u63a5\u5f85",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u9053\u5177\u9648\u5217 \u6837\u54c1\u6446\u653e\uff08PGC\u7ec4AE/\u54c1\u724cAE\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 2000.0,
                sku_code: "CRE01001",
                content: "\u573a\u52a1",
                extend_type: 2,
                purchase_price: 200.0,
                offer_id: 57
              },
              type: 101,
              extend: "175",
              real_pay: 300.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29966
            },
            {
              buy_real_price: 300.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u9053\u5177\u9648\u5217 \u6837\u54c1\u6446\u653e\uff08PGC\u7ec4AE/\u54c1\u724cAE\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 2000.0,
                sku_code: "CRE01001",
                content: "\u573a\u52a1",
                extend_type: 2,
                purchase_price: 200.0,
                offer_id: 57
              },
              type: 101,
              extend: "848",
              real_pay: 300.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30409
            },
            {
              buy_real_price: 200.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u9053\u5177\u9648\u5217 \u6837\u54c1\u6446\u653e\uff08PGC\u7ec4AE/\u54c1\u724cAE\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 2000.0,
                sku_code: "CRE01001",
                content: "\u573a\u52a1",
                extend_type: 2,
                purchase_price: 200.0,
                offer_id: 57
              },
              type: 101,
              extend: "849",
              real_pay: 200.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30410
            },
            {
              buy_real_price: 2130.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u827a\u4eba\u4fdd\u9669",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29898
            },
            {
              buy_real_price: 1865.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u4eae\u529b \u7269\u6599\u5236\u4f5c",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29961
            },
            {
              buy_real_price: 4000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u738b\u901a\u6280\u672f\u6267\u884c",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30411
            },
            {
              buy_real_price: 1000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 4,
                name: "",
                spec: "",
                num: "1",
                year_price: 5000.0,
                non_year_price: 5000.0,
                sku_code: "CON00104",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              type: 103,
              extend: "600",
              real_pay: 500.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29962
            },
            {
              buy_real_price: 1000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 4,
                name: "",
                spec: "",
                num: "1",
                year_price: 5000.0,
                non_year_price: 5000.0,
                sku_code: "CON00104",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              type: 103,
              extend: "145",
              real_pay: 500.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29963
            },
            {
              buy_real_price: 12600.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u4f4f\u5bbf\u8d39\uff08\u827a\u4eba\u56e2\u961f+\u6267\u884c",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30374
            },
            {
              buy_real_price: 14745.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u827a\u4eba\u7528\u8f66",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30375
            },
            {
              buy_real_price: 7546.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u642d\u5efa6194+1352",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30376
            },
            {
              buy_real_price: 4860.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u8d34\u4fdd1380+3480",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30377
            },
            {
              buy_real_price: 5721.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u827a\u4eba\u56e2\u961f\u673a\u7968\u706b\u8f66\u7968",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30378
            },
            {
              buy_real_price: 60000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u827a\u4eba\u5986\u53d1",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30866
            },
            {
              buy_real_price: 3777.41,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u9910\u996e2428.6+\u6253\u8f66\u79df\u8f661348.81",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30912
            },
            {
              buy_real_price: 3637.3,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u827a\u4eba\u56e2\u961f\u57ab\u4ed8\u9910\u996e2663+\u6253\u8f66974.3",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 31206
            },
            {
              buy_real_price: 7732.57,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u6742\u8d39",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 31342
            },
            {
              buy_real_price: 503.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u706b\u8f66\u796887+\u4e3b\u6301\u4eba\u670d\u88c5369+\u7b7e\u540d\u716747",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 31524
            }
          ],
          business: {
            name: "\u5b89\u601d\u540d",
            staff_id: 483
          },
          pay_time: "2025-09-11",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-28",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-07-02",
          review_status: 1,
          gr_files: [],
          invoice_time: "",
          name: "20250430\u73c0\u83b1\u96c5\u6296\u97f3\u9a6c\u67cf\u5168PGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 90.0,
          location: "",
          creater_id: 206,
          ae: {
            name: "\u5e94\u96ef\u742a",
            staff_id: 372
          },
          pgc_brand_id: 84,
          pgc_studio_id: 32,
          business_earn: 90.0,
          status: 6,
          creater_email: "xuxh@miicore.com",
          project_type: 1,
          start_time: "2025-04-28 00:00:00",
          project_id: 1631,
          code: "ssit003022025042802",
          creater_name: "\u5f90\u6653\u6db5",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u4ec5\u8c03\u8bd5"],
          items: [
            {
              type: 1,
              buy_real_price: 0.0,
              extend: "1",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29860,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SIT00302",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                content:
                  "\u54c1\u724c\u76f4\u64ad\u95f4\uff08\u5546\u573a\u7b49\u975e\u660e\u661f\u76f4\u64ad\uff09",
                type: 1,
                extend_type: 1,
                purchase_price: 0.0,
                offer_id: 22
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 9000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29861,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SET00301",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u9053\u5177\u6837\u54c1\u7b49",
                content: "\u5176\u4ed6\u589e\u9879\u8d39\u7528",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 27
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 428.24,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "463",
              real_pay: 428.24,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29859
            },
            {
              buy_real_price: 3180.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {},
              type: 102,
              extend: "1,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29857
            },
            {
              buy_real_price: 900.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u5320\u81f4",
              supplier_offer: {},
              type: 102,
              extend: "1,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29858
            },
            {
              buy_real_price: 50.8,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "2\u4eba\u5348\u9910",
              supplier_offer: {},
              type: 104,
              extend: "2",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30136
            },
            {
              buy_real_price: 106.42,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u7269\u659952.42+\u95ea\u900154",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30137
            },
            {
              buy_real_price: 390.42,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u6253\u8f66230.42+\u706b\u8f66\u7968160",
              supplier_offer: {},
              type: 104,
              extend: "1",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30138
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "2025-09-11",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-28",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-07",
          review_status: 1,
          gr_files: [
            {
              name: "\u8482\u4f73\u5a77\u65e5\u64ad\u95f4\u8c03\u5149gr.pdf",
              uid: 1746702183847,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_ssit003022025042802_1746702110278..pdf"
            }
          ],
          invoice_time: "",
          name: "20250428\u8482\u4f73\u5a77\u5929\u732b\u4ec5\u8c03\u8bd5PUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 1296.0,
          location: "",
          creater_id: 156,
          ae: {
            name: "\u5b89\u7f57\u5170",
            staff_id: 756
          },
          pgc_brand_id: 39,
          pgc_studio_id: 29,
          business_earn: 1296.0,
          status: 6,
          creater_email: "hejj@miicore.com",
          project_type: 1,
          start_time: "2025-04-28 00:00:00",
          project_id: 1629,
          code: "ssit003022025042801",
          creater_name: "\u8d3a\u4f73\u6770",
          co_type: 0,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u8463\u8273\u9896"],
          items: [
            {
              type: 1,
              buy_real_price: 0.0,
              extend: "2:3,0",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29814,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00302",
                content:
                  "\u54c1\u724c\u76f4\u64ad\u95f4\uff08\u5546\u573a\u7b49\u975e\u660e\u661f\u76f4\u64ad\uff09",
                type: 1,
                extend_type: 1,
                purchase_price: 0.0,
                offer_id: 22
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 75000.0,
              description: "\u573a\u5730\u8d39\u7528",
              num: "1",
              invoice_status: 0,
              item_id: 29815,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u9053\u5177\u6837\u54c1\u7b49",
                sku_code: "SET00301",
                content: "\u5176\u4ed6\u589e\u9879\u8d39\u7528",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 27
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 54600.0,
              description: "\u6280\u672f\u6267\u884c\u8d39\u7528",
              num: "1",
              invoice_status: 0,
              item_id: 29816,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u9053\u5177\u6837\u54c1\u7b49",
                sku_code: "SET00301",
                content: "\u5176\u4ed6\u589e\u9879\u8d39\u7528",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 27
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 7627.06,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "35",
              real_pay: 7627.06,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29813
            },
            {
              buy_real_price: 200.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "1\u5929\u573a\u52a1",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u9053\u5177\u9648\u5217 \u6837\u54c1\u6446\u653e\uff08PGC\u7ec4AE/\u54c1\u724cAE\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 2000.0,
                sku_code: "CRE01001",
                content: "\u573a\u52a1",
                extend_type: 2,
                purchase_price: 200.0,
                offer_id: 57
              },
              type: 101,
              extend: "257",
              real_pay: 200.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30388
            },
            {
              buy_real_price: 5000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u738b\u901a\u7f51\u7edc",
              supplier_offer: {},
              type: 102,
              extend: "3,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29925
            },
            {
              buy_real_price: 40000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u9152\u5e97\u8d39\u7528",
              supplier_offer: {},
              type: 104,
              extend: "3",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29892
            },
            {
              buy_real_price: 6833.4,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u5b89\u7f57\u5170\u62a5\u9500\u9910\u996e\u7269\u6599\u4ea4\u901a",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30672
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "2025-09-11",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-28",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-26",
          review_status: 1,
          gr_files: [
            {
              name:
                "20250428\u6b27\u83b1\u96c5\u6296\u97f3\u8463\u8273\u9896PUGC.pptx",
              uid: 1749469932897,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_ssit003022025042801_1749469923741..pptx"
            }
          ],
          invoice_time: "",
          name: "20250428\u6b27\u83b1\u96c5\u6296\u97f3\u8463\u8273\u9896PUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 554.55,
          location: "",
          creater_id: 3,
          ae: {
            name: "",
            staff_id: ""
          },
          pgc_brand_id: 40,
          pgc_studio_id: 2,
          business_earn: 554.55,
          status: 7,
          creater_email: "",
          project_type: 1,
          start_time: "2025-04-28 00:00:00",
          project_id: 1628,
          code: "ssit001012025042801",
          creater_name: "Eason",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u9648\u6587\u5a23\u57ab\u4ed8"],
          items: [
            {
              type: 1,
              buy_real_price: 2000.0,
              extend: "1",
              buy_real_charge: 55454.72,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29810,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SIT00101",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "10\u5e73\u7c73\u4ee5\u4e0a",
                content: "\u58a8\u81e3\u6807\u51c6\u76f4\u64ad\u95f4",
                type: 1,
                extend_type: 1,
                purchase_price: 2000.0,
                offer_id: 17
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 920.52,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "665",
              real_pay: 920.52,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29808
            },
            {
              buy_real_price: 50413.66,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {},
              type: 104,
              extend: "4",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29809
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "2025-07-15",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-28",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-04-28",
          review_status: 1,
          gr_files: [],
          invoice_time: "",
          name:
            "20250428\u6b27\u83b1\u96c5\u5929\u732b\u9648\u6587\u5a23\u57ab\u4ed8PUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 62.0,
          location: "",
          creater_id: 156,
          ae: {
            name: "\u91d1\u4f73\u6d0b",
            staff_id: 755
          },
          pgc_brand_id: 39,
          pgc_studio_id: 29,
          business_earn: 62.0,
          status: 5,
          creater_email: "hejj@miicore.com",
          project_type: 1,
          start_time: "2025-04-23 00:00:00",
          project_id: 1624,
          code: "ssit003022025042302",
          creater_name: "\u8d3a\u4f73\u6770",
          co_type: 0,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u9762\u819c\u5236\u4f5c"],
          items: [
            {
              type: 1,
              buy_real_price: 0.0,
              extend: "2:14,",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29724,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00302",
                content:
                  "\u54c1\u724c\u76f4\u64ad\u95f4\uff08\u5546\u573a\u7b49\u975e\u660e\u661f\u76f4\u64ad\uff09",
                type: 1,
                extend_type: 1,
                purchase_price: 0.0,
                offer_id: 22
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 10000.0,
              extend: "",
              buy_real_charge: 6200.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29725,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 30000.0,
                year_price: 20000.0,
                num: "1",
                spec: "\u5b9e\u666f\u5236\u4f5c\u548c\u642d\u5efa",
                sku_code: "SET00102",
                content: "\u76f4\u64ad\u80cc\u666f\u5b9e\u666f",
                type: 5,
                extend_type: 0,
                purchase_price: 10000.0,
                offer_id: 24
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 675.18,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "35",
              real_pay: 675.18,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29723
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-23",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-26",
          review_status: 1,
          gr_files: [
            {
              name:
                "20250411\u6b27\u83b1\u96c5\u6296\u97f3\u9762\u819c\u6237\u5916\u4e13\u573aPUGC.pptx",
              uid: 1763005643788,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_ssit003022025042302_1763005623118..pptx"
            }
          ],
          invoice_time: "",
          name:
            "20250423\u6b27\u83b1\u96c5\u6296\u97f3\u9762\u819c\u5236\u4f5cPUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 30.0,
          location: "",
          creater_id: 156,
          ae: {
            name: "",
            staff_id: ""
          },
          pgc_brand_id: 136,
          pgc_studio_id: 32,
          business_earn: 30.0,
          status: 7,
          creater_email: "hejj@miicore.com",
          project_type: 1,
          start_time: "2025-04-23 00:00:00",
          project_id: 1623,
          code: "ssit003022025042301",
          creater_name: "\u8d3a\u4f73\u6770",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u6a0a\u632f\u4e1c\u811a\u672c"],
          items: [
            {
              type: 1,
              buy_real_price: 0.0,
              extend: "2:14,",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29721,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00302",
                content:
                  "\u54c1\u724c\u76f4\u64ad\u95f4\uff08\u5546\u573a\u7b49\u975e\u660e\u661f\u76f4\u64ad\uff09",
                type: 1,
                extend_type: 1,
                purchase_price: 0.0,
                offer_id: 22
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 4,
              buy_real_price: 1500.0,
              extend: "333",
              buy_real_charge: 3000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29722,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 30000.0,
                year_price: 10000.0,
                num: "1",
                spec: "\u5b98\u65b9\u53f0",
                sku_code: "CON00102",
                content: "\u5185\u5bb9\u7b56\u5212-A\u7ea7\u8d44\u6e90BD",
                type: 4,
                extend_type: 2,
                purchase_price: 1500.0,
                offer_id: 35
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 58.33,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "35",
              real_pay: 58.33,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29720
            },
            {
              buy_real_price: 2000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 4,
                name: "",
                spec: "",
                num: "1",
                year_price: 5000.0,
                non_year_price: 5000.0,
                sku_code: "CON00104",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              type: 103,
              extend: "333",
              real_pay: 1000.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30373
            },
            {
              buy_real_price: 416.71,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u8e29\u70b9\u8d39\u7528-echo",
              supplier_offer: {},
              type: 104,
              extend: "1",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30534
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "2025-12-12",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-23",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-26",
          review_status: 1,
          gr_files: [
            {
              name:
                "0510\u96c5\u6f3e x \u6a0a\u632f\u4e1c\u676d\u5dde\u6d3b\u52a8\u811a\u672c-V0507.xlsx",
              uid: 1749448495806,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_ssit003022025042301_1749448487961..xlsx"
            }
          ],
          invoice_time: "",
          name:
            "20250423\u96c5\u6f3e\u6296\u97f3\u6a0a\u632f\u4e1c\u811a\u672cPUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 1799.09,
          location: "",
          creater_id: 156,
          ae: {
            name: "",
            staff_id: ""
          },
          pgc_brand_id: 136,
          pgc_studio_id: 51,
          business_earn: 1799.09,
          status: 5,
          creater_email: "hejj@miicore.com",
          project_type: 1,
          start_time: "2025-04-30 00:00:00",
          project_id: 1622,
          code: "ssit003022025043003",
          creater_name: "\u8d3a\u4f73\u6770",
          co_type: 0,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u8463\u5148\u751f\u6280\u672f\u6267\u884c"],
          items: [
            {
              type: 1,
              buy_real_price: 0.0,
              extend: "2:14,0",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29718,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 0.0,
                year_price: 0.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00302",
                content:
                  "\u54c1\u724c\u76f4\u64ad\u95f4\uff08\u5546\u573a\u7b49\u975e\u660e\u661f\u76f4\u64ad\uff09",
                type: 1,
                extend_type: 1,
                purchase_price: 0.0,
                offer_id: 22
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 179909.43,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29719,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u9053\u5177\u6837\u54c1\u7b49",
                sku_code: "SET00301",
                content: "\u5176\u4ed6\u589e\u9879\u8d39\u7528",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 27
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 15588.18,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "35",
              real_pay: 15588.18,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29717
            },
            {
              buy_real_price: 7552.39,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u4f4f\u5bbf",
              supplier_offer: {},
              type: 104,
              extend: "1",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29929
            },
            {
              buy_real_price: 18853.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u673a\u7968",
              supplier_offer: {},
              type: 104,
              extend: "1",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29930
            },
            {
              buy_real_price: 138.7,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u6253\u8f6647.98+\u95ea\u900128.1+\u5956\u724c62.62",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30606
            },
            {
              buy_real_price: 3330.91,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u4ea4\u901a\u8d39\u7528-\u5927\u9ed1",
              supplier_offer: {},
              type: 104,
              extend: "1",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30839
            },
            {
              buy_real_price: 8323.71,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u9910\u996e6062.06+\u6253\u8f662261.65",
              supplier_offer: {},
              type: 104,
              extend: "2",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30845
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-23",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-26",
          review_status: 1,
          gr_files: [
            {
              name:
                "20250430\u96c5\u6f3e\u6296\u97f3\u8463\u5148\u751f\u6280\u672f\u6267\u884cPUGC .pptx",
              uid: 1749470269188,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_ssit003022025043003_1749469953374..pptx"
            }
          ],
          invoice_time: "",
          name:
            "20250430\u96c5\u6f3e\u6296\u97f3\u8463\u5148\u751f\u6280\u672f\u6267\u884cPUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 682.86,
          location: "",
          creater_id: 156,
          ae: {
            name: "\u91d1\u4f73\u6d0b",
            staff_id: 755
          },
          pgc_brand_id: 196,
          pgc_studio_id: 36,
          business_earn: 682.86,
          status: 6,
          creater_email: "hejj@miicore.com",
          project_type: 3,
          start_time: "2025-04-23 00:00:00",
          project_id: 1621,
          code: "asit003012025042301",
          creater_name: "\u8d3a\u4f73\u6770",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 1,
          kols: ["\u6bdb\u6208\u5e73\u4e13\u573a"],
          items: [
            {
              type: 1,
              buy_real_price: 30000.0,
              extend: "2:14,",
              buy_real_charge: 0.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29715,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 35000.0,
                year_price: 32000.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                sku_code: "SIT00301",
                content: "\u9152\u5e97\u7b49\u5176\u4ed6\u5916\u68da",
                type: 1,
                extend_type: 1,
                purchase_price: 30000.0,
                offer_id: 21
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 68285.85,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29716,
              status: 4,
              supplier_offer: {
                name: "",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u9053\u5177\u6837\u54c1\u7b49",
                sku_code: "SET00301",
                content: "\u5176\u4ed6\u589e\u9879\u8d39\u7528",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 27
              },
              supplier: {
                location: "",
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 2641.67,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "35",
              real_pay: 2641.67,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29714
            },
            {
              buy_real_price: 6000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "seven\u8bbe\u8ba1\u8d39\u7528",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30755
            },
            {
              buy_real_price: 8000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "6\u4e2a\u5c0f\u4e13\u573a\uff0c2\u4e2aPUGC\uff0c\u52a0\u6267\u884c\u8d39\u7528 ",
              supplier_offer: {
                type: 4,
                name: "",
                spec: "",
                num: "1",
                year_price: 5000.0,
                non_year_price: 5000.0,
                sku_code: "CON00104",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              type: 103,
              extend: "145",
              real_pay: 4000.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 30387
            },
            {
              buy_real_price: 25500.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u7a9c\u65af\u67b6\u6210\u672c",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30389
            },
            {
              buy_real_price: 1686.3,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u7269\u6599\u8d39\u7528\uff0c\u6253\u8f66\u8d39\u7b49-\u5927\u9ed1",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30754
            }
          ],
          business: {
            name: "",
            staff_id: ""
          },
          pay_time: "2026-03-13",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "",
          create_time: "2025-04-23",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-26",
          review_status: 1,
          gr_files: [
            {
              name:
                "\u6bdb\u6208\u5e73X\u8d85\u7ea7\u54c1\u724c\u65e5\u76f4\u64ad\u590d\u76d8\u7ed3\u6848.pdf",
              uid: 1749450205827,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_asit003012025042301_1749450199169..pdf"
            }
          ],
          invoice_time: "",
          name:
            "20250423\u6bdb\u6208\u5e73\u6296\u97f3\u6bdb\u6208\u5e73\u4e13\u573aPUGC",
          tax_rate_type: 1
        },
        {
          ae_earn: 1447.0,
          location: "",
          creater_id: 335,
          ae: {
            name: "\u5f90\u6653\u6db5",
            staff_id: 464
          },
          pgc_brand_id: 21,
          pgc_studio_id: 29,
          business_earn: 1447.0,
          status: 6,
          creater_email: "jinni@miicore.com",
          project_type: 3,
          start_time: "2025-04-25 00:00:00",
          project_id: 1620,
          code: "asit003012025042501",
          creater_name: "\u91d1\u6653\u94b0",
          co_type: 2,
          version: "2023-02-27",
          pgc_type: 0,
          kols: ["\u5f20\u5eb7\u4e50\u5f20\u6587\u6615"],
          items: [
            {
              type: 1,
              buy_real_price: 30000.0,
              extend: "2:14,",
              buy_real_charge: 35000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29683,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SIT00301",
                non_year_price: 35000.0,
                year_price: 32000.0,
                num: "1",
                spec: "50\u5e73\u7c73\u4ee5\u4e0a",
                content: "\u9152\u5e97\u7b49\u5176\u4ed6\u5916\u68da",
                type: 1,
                extend_type: 1,
                purchase_price: 30000.0,
                offer_id: 21
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 2,
              buy_real_price: 6000.0,
              extend: "",
              buy_real_charge: 9000.0,
              description: "",
              num: "3",
              invoice_status: 0,
              item_id: 29685,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "CRE00401",
                non_year_price: 3000.0,
                year_price: 2000.0,
                num: "1",
                spec:
                  "\u8d1f\u8d23\u73b0\u573a\u62cd\u6444\u753b\u9762 Vmix\u7eff\u5e55\u6307\u5b9a",
                content: "\u6444\u50cf\u5e08-S\u7ea7",
                type: 2,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 336
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 2,
              buy_real_price: 500.0,
              extend: "",
              buy_real_charge: 1500.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29686,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "CRE00701",
                non_year_price: 1500.0,
                year_price: 1000.0,
                num: "1",
                spec:
                  "\u8d1f\u8d23\u6240\u6709\u8bbe\u5907\u8fde\u63a5\uff0c\u5f55\u50cf\uff0c\u63a8\u6d41",
                content: "\u63a8\u6d41\u5e08-S\u7ea7",
                type: 2,
                extend_type: 0,
                purchase_price: 500.0,
                offer_id: 340
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 2,
              buy_real_price: 100.0,
              extend: "522",
              buy_real_charge: 500.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29687,
              status: 4,
              supplier_offer: {
                name: "\u9898\u8bcd",
                sku_code: "CRE01101",
                non_year_price: 500.0,
                year_price: 500.0,
                num: "1",
                spec: "\u9898\u8bcd",
                content: "\u9898\u8bcd",
                type: 2,
                extend_type: 2,
                purchase_price: 100.0,
                offer_id: 137
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 1000.0,
              extend: "",
              buy_real_charge: 3000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29688,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00101",
                non_year_price: 3000.0,
                year_price: 2000.0,
                num: "1",
                spec: "BMD ATEM 1 M/E Advance Panel 4k",
                content: "\u5bfc\u64ad\u53f0-S\u7ea7",
                type: 3,
                extend_type: 0,
                purchase_price: 1000.0,
                offer_id: 316
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 600.0,
              extend: "",
              buy_real_charge: 1000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29689,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00201",
                non_year_price: 1000.0,
                year_price: 600.0,
                num: "1",
                spec: "Sony PXW z280 4K/Z580 ",
                content: "\u6444\u50cf\u8bbe\u5907-S\u7ea7",
                type: 3,
                extend_type: 0,
                purchase_price: 600.0,
                offer_id: 318
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 600.0,
              extend: "",
              buy_real_charge: 2000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29690,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00301",
                non_year_price: 1000.0,
                year_price: 300.0,
                num: "1",
                spec: "Sony FX9V",
                content:
                  "\u8f85\u52a9\u6444\u50cf-\u6444\u50cf\u673a\u63a7\u5236\u5355\u5143",
                type: 3,
                extend_type: 0,
                purchase_price: 300.0,
                offer_id: 319
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 600.0,
              extend: "",
              buy_real_charge: 1000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29691,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00302",
                non_year_price: 500.0,
                year_price: 300.0,
                num: "1",
                spec: "Atomos Shinobi",
                content: "\u8f85\u52a9\u6444\u50cf-\u76d1\u89c6\u5668",
                type: 3,
                extend_type: 0,
                purchase_price: 300.0,
                offer_id: 320
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 800.0,
              extend: "",
              buy_real_charge: 2000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29692,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00303",
                non_year_price: 1000.0,
                year_price: 500.0,
                num: "1",
                spec: "",
                content: "\u8f85\u52a9\u6444\u50cf-\u5f55\u50cf\u673a",
                type: 3,
                extend_type: 0,
                purchase_price: 400.0,
                offer_id: 321
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 600.0,
              extend: "",
              buy_real_charge: 4000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29693,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00304",
                non_year_price: 2000.0,
                year_price: 1000.0,
                num: "1",
                spec: "",
                content:
                  "\u8f85\u52a9\u6444\u50cf-\u58f0\u97f3\u753b\u9762\u52a0\u5d4c\u8bbe\u5907",
                type: 3,
                extend_type: 0,
                purchase_price: 300.0,
                offer_id: 322
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 600.0,
              extend: "",
              buy_real_charge: 2000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29694,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00402",
                non_year_price: 1000.0,
                year_price: 500.0,
                num: "1",
                spec: "",
                content:
                  "\u89c6\u9891\u91c7\u96c6-\u89c6\u98911\u8fdb2\u51fa\u8bbe\u5907",
                type: 3,
                extend_type: 0,
                purchase_price: 300.0,
                offer_id: 323
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 3000.0,
              extend: "",
              buy_real_charge: 6000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29695,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00701",
                non_year_price: 3000.0,
                year_price: 2000.0,
                num: "1",
                spec: "",
                content: "\u63a8\u6d41\u8bbe\u5907-S\u7ea7",
                type: 3,
                extend_type: 0,
                purchase_price: 1500.0,
                offer_id: 327
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 500.0,
              extend: "",
              buy_real_charge: 1000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29696,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00801",
                non_year_price: 1000.0,
                year_price: 500.0,
                num: "1",
                spec: "50\u5bf8\u7535\u89c6\u673a+\u7535\u8111",
                content: "\u8f93\u51fa\u8bbe\u5907-\u9898\u8bcd\u5668",
                type: 3,
                extend_type: 0,
                purchase_price: 500.0,
                offer_id: 328
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 4000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29697,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU00901",
                non_year_price: 2000.0,
                year_price: 1500.0,
                num: "1",
                spec: "",
                content: "\u8fbe\u82ac\u5947\u8c03\u8272",
                type: 3,
                extend_type: 0,
                purchase_price: 1000.0,
                offer_id: 332
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 3,
              buy_real_price: 1200.0,
              extend: "",
              buy_real_charge: 3000.0,
              description: "",
              num: "6",
              invoice_status: 0,
              item_id: 29698,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "EQU01002",
                non_year_price: 500.0,
                year_price: 200.0,
                num: "1",
                spec: "",
                content:
                  "\u7f51\u7edc\u8bbe\u5907-\u8def\u7531\u5668+\u7f51\u7ebf\u8017\u6750",
                type: 3,
                extend_type: 0,
                purchase_price: 200.0,
                offer_id: 334
              },
              supplier: {
                name:
                  "\u82cf\u5dde\u79c0\u5361\u6280\u672f\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 14,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 4,
              buy_real_price: 1000.0,
              extend: "327",
              buy_real_charge: 5000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29699,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "CON00104",
                non_year_price: 5000.0,
                year_price: 5000.0,
                num: "1",
                spec: "",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                type: 4,
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 20000.0,
              extend: "",
              buy_real_charge: 60000.0,
              description: "",
              num: "2",
              invoice_status: 0,
              item_id: 29700,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SET00102",
                non_year_price: 30000.0,
                year_price: 20000.0,
                num: "1",
                spec: "\u5b9e\u666f\u5236\u4f5c\u548c\u642d\u5efa",
                content: "\u76f4\u64ad\u80cc\u666f\u5b9e\u666f",
                type: 5,
                extend_type: 0,
                purchase_price: 10000.0,
                offer_id: 24
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 500.0,
              extend: "",
              buy_real_charge: 3000.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29702,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SET00103",
                non_year_price: 3000.0,
                year_price: 0.0,
                num: "1",
                spec: "KT\u677f\u5355\u6b21\u4f7f\u7528",
                content: "\u76f4\u64ad\u80cc\u666fKT\u677f",
                type: 5,
                extend_type: 0,
                purchase_price: 500.0,
                offer_id: 25
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              type: 5,
              buy_real_price: 2000.0,
              extend: "",
              buy_real_charge: 1700.0,
              description: "",
              num: "1",
              invoice_status: 0,
              item_id: 29703,
              status: 4,
              supplier_offer: {
                name: "",
                sku_code: "SET00201",
                non_year_price: 2000.0,
                year_price: 2000.0,
                num: "1",
                spec: "\u6240\u6709\u73b0\u573a\u9053\u5177\u5e03\u7f6e",
                content: "\u80cc\u666f\u9053\u5177\u8fd0\u8f93",
                type: 5,
                extend_type: 0,
                purchase_price: 2000.0,
                offer_id: 26
              },
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              }
            },
            {
              buy_real_price: 3911.34,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u5bf9\u63a5\u9879\u76ee\u9700\u6c42\u53ca\u73b0\u573a\u7edf\u7b79\uff08PGC\u7ec4\uff09",
                num: "1",
                year_price: 3000.0,
                non_year_price: 5000.0,
                sku_code: "CRE00102",
                content: "\u9879\u76ee\u7edf\u7b79PM-A\u7ea7",
                extend_type: 2,
                purchase_price: 2000.0,
                offer_id: 45
              },
              type: 101,
              extend: "409",
              real_pay: 3911.34,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29682
            },
            {
              buy_real_price: 500.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u8282\u76ee\u5f69\u6392/\u5185\u5bb9\u5f69\u6392/\u73b0\u573a\u7f16\u5bfc\uff08\u7b56\u5212\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 3000.0,
                sku_code: "CRE00202",
                content: "\u73b0\u573a\u5bfc\u64ad-A\u7ea7",
                extend_type: 2,
                purchase_price: 300.0,
                offer_id: 48
              },
              type: 101,
              extend: "327",
              real_pay: 500.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29885
            },
            {
              buy_real_price: 400.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u573a\u52a1+PR",
              supplier_offer: {
                type: 2,
                name: "",
                spec:
                  "\u9053\u5177\u9648\u5217 \u6837\u54c1\u6446\u653e\uff08PGC\u7ec4AE/\u54c1\u724cAE\uff09",
                num: "1",
                year_price: 2000.0,
                non_year_price: 2000.0,
                sku_code: "CRE01001",
                content: "\u573a\u52a1",
                extend_type: 2,
                purchase_price: 200.0,
                offer_id: 57
              },
              type: 101,
              extend: "480",
              real_pay: 400.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29886
            },
            {
              buy_real_price: 200.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "",
                spec: "\u76f4\u64ad\u4e2d\u63a7\u53f0",
                num: "1",
                year_price: 500.0,
                non_year_price: 1000.0,
                sku_code: "CRE00801",
                content: "\u4e2d\u63a7",
                extend_type: 3,
                purchase_price: 30.0,
                offer_id: 55
              },
              type: 101,
              extend: "568",
              real_pay: 200.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29888
            },
            {
              buy_real_price: 200.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 2,
                name: "\u9898\u8bcd",
                spec: "\u9898\u8bcd",
                num: "1",
                year_price: 500.0,
                non_year_price: 500.0,
                sku_code: "CRE01101",
                content: "\u9898\u8bcd",
                extend_type: 2,
                purchase_price: 100.0,
                offer_id: 137
              },
              type: 101,
              extend: "522",
              real_pay: 200.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29889
            },
            {
              buy_real_price: 8800.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u6c5f\u8001\u677f\u642d\u5efa",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29869
            },
            {
              buy_real_price: 3000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u732b\u5934\u7f51\u7edc",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29870
            },
            {
              buy_real_price: 80.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "\u4eae\u529b",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29871
            },
            {
              buy_real_price: 48000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description:
                "\u6280\u672f\u738b\u8001\u5e081.8W,\u4e3b\u6301\u4eba\u57ab\u4ed83W",
              supplier_offer: {},
              type: 102,
              extend: "14,0",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 29884
            },
            {
              buy_real_price: 2000.0,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "",
              supplier_offer: {
                type: 4,
                name: "",
                spec: "",
                num: "1",
                year_price: 5000.0,
                non_year_price: 5000.0,
                sku_code: "CON00104",
                content: "\u5185\u5bb9\u7b56\u5212-\u5609\u5bbe\u811a\u672cA",
                extend_type: 2,
                purchase_price: 1000.0,
                offer_id: 37
              },
              type: 103,
              extend: "327",
              real_pay: 1000.0,
              num: "0",
              supplier: {
                name:
                  "\u4e0a\u6d77\u8288\u58f3\u7f51\u7edc\u79d1\u6280\u6709\u9650\u516c\u53f8",
                location: "",
                offers: [],
                contact: {},
                tax_number: "",
                supplier_id: 1,
                services: [],
                status: 0,
                service_location: ""
              },
              item_id: 29887
            },
            {
              buy_real_price: 1846.22,
              buy_real_charge: 0,
              is_cost: 1,
              invoice_status: 0,
              status: 4,
              description: "1846.22",
              supplier_offer: {},
              type: 104,
              extend: "5",
              real_pay: 0.0,
              num: "0",
              supplier: {},
              item_id: 30152
            }
          ],
          business: {
            name: "chengxi",
            staff_id: 79
          },
          pay_time: "2025-06-11",
          pay_status: 0,
          brand_name: "",
          admin_check: 1,
          po: "\u738b\u8001\u5e08\u6210\u672c\u5b9e\u9645\u4e3a49800",
          create_time: "2025-04-21",
          brand: {
            name: "PGC\u9ed8\u8ba4",
            status: 0,
            brand_id: 9999
          },
          end_time: "2025-05-07",
          review_status: 1,
          gr_files: [
            {
              name:
                "\u8d44\u751f\u5802x\u53cc\u660e\u661f425\u76f4\u64ad\u590d\u76d8.pptx",
              uid: 1746592117072,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_asit003012025042501_1746592091721..pptx"
            },
            {
              name:
                "425\u8d44\u751f\u5802X\u53cc\u660e\u661f\u76f4\u64ad\u811a\u672c0423.docx",
              uid: 1746592130597,
              status: "success",
              url:
                "https://mochen-live-oss.oss-cn-shanghai.aliyuncs.com/GR_asit003012025042501_1746592117063..docx"
            }
          ],
          invoice_time: "",
          name:
            "20250425\u8d44\u751f\u5802\u5929\u732b\u5f20\u5eb7\u4e50\u5f20\u6587\u6615PGC",
          tax_rate_type: 1
        }
      ],
      lives: [],
      total_num: 47,
      pgc_brands: [
        {
          name: "\u96c5\u8bd7\u5170\u9edb\u5929\u732b",
          type: 1,
          total_project_cnt: 92,
          status: 0,
          pgc_brand_id: 4
        },
        {
          name: "\u96c5\u8bd7\u5170\u9edb\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 38,
          status: 0,
          pgc_brand_id: 5
        },
        {
          name: "\u96c5\u8bd7\u5170\u9edb\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 6
        },
        {
          name: "\u96c5\u8bd7\u5170\u9edb\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 7
        },
        {
          name: "\u5029\u78a7\u5929\u732b",
          type: 1,
          total_project_cnt: 23,
          status: 0,
          pgc_brand_id: 8
        },
        {
          name: "\u5029\u78a7\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 9
        },
        {
          name: "\u5029\u78a7\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 10
        },
        {
          name: "\u5029\u78a7\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 11
        },
        {
          name: "\u5b9d\u6d01\u5929\u732b",
          type: 1,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 14
        },
        {
          name: "\u5b9d\u6d01\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 15
        },
        {
          name: "\u5b9d\u6d01\u6296\u97f3",
          type: 3,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 16
        },
        {
          name: "\u7f8e\u5b9d\u83b2\u5929\u732b",
          type: 1,
          total_project_cnt: 7,
          status: 0,
          pgc_brand_id: 17
        },
        {
          name: "\u7f8e\u5b9d\u83b2\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 18
        },
        {
          name: "\u7f8e\u5b9d\u83b2\u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 19
        },
        {
          name: "\u7f8e\u5b9d\u83b2\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 20
        },
        {
          name: "\u8d44\u751f\u5802\u5929\u732b",
          type: 1,
          total_project_cnt: 24,
          status: 0,
          pgc_brand_id: 21
        },
        {
          name: "\u8d44\u751f\u5802\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 10,
          status: 0,
          pgc_brand_id: 22
        },
        {
          name: "\u8d44\u751f\u5802\u6296\u97f3",
          type: 3,
          total_project_cnt: 12,
          status: 0,
          pgc_brand_id: 23
        },
        {
          name: "\u8d44\u751f\u5802\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 26,
          status: 0,
          pgc_brand_id: 24
        },
        {
          name: "\u5f90\u6c47\u6587\u65c5\u6296\u97f3",
          type: 3,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 25
        },
        {
          name: "Aveda\u5929\u732b",
          type: 1,
          total_project_cnt: 20,
          status: 0,
          pgc_brand_id: 26
        },
        {
          name: "Aveda\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 27
        },
        {
          name: "Aveda\u6296\u97f3",
          type: 3,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 28
        },
        {
          name: "Aveda\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 11,
          status: 0,
          pgc_brand_id: 29
        },
        {
          name: "\u7956\u739b\u73d1\u5929\u732b",
          type: 1,
          total_project_cnt: 57,
          status: 0,
          pgc_brand_id: 30
        },
        {
          name: "\u7956\u739b\u73d1\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 16,
          status: 0,
          pgc_brand_id: 31
        },
        {
          name: "\u7956\u739b\u73d1\u6296\u97f3",
          type: 3,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 32
        },
        {
          name: "\u7956\u739b\u73d1\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 33
        },
        {
          name: "\u6d77\u65c5larmer\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 34
        },
        {
          name: "fresh\u5929\u732b",
          type: 1,
          total_project_cnt: 26,
          status: 0,
          pgc_brand_id: 35
        },
        {
          name: "fresh\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 36
        },
        {
          name: "fresh\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 37
        },
        {
          name: "fresh\u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 38
        },
        {
          name: "\u6b27\u83b1\u96c5\u6296\u97f3",
          type: 3,
          total_project_cnt: 147,
          status: 0,
          pgc_brand_id: 39
        },
        {
          name: "\u6b27\u83b1\u96c5\u5929\u732b",
          type: 1,
          total_project_cnt: 58,
          status: 0,
          pgc_brand_id: 40
        },
        {
          name: "\u6b27\u83b1\u96c5\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 18,
          status: 0,
          pgc_brand_id: 41
        },
        {
          name: "\u6b27\u83b1\u96c5\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 9,
          status: 0,
          pgc_brand_id: 42
        },
        {
          name: "\u6f58\u5a77\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 13,
          status: 0,
          pgc_brand_id: 43
        },
        {
          name: "CDF\u591a\u5e73\u53f0",
          type: 5,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 44
        },
        {
          name: "CT\u5929\u732b",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 45
        },
        {
          name: "\u5361\u5730\u4e9a\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 46
        },
        {
          name: "\u5361\u5730\u4e9a\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 47
        },
        {
          name: "\u5361\u5730\u4e9a\u6296\u97f3",
          type: 3,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 48
        },
        {
          name: "\u5361\u5730\u4e9a\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 49
        },
        {
          name: "\u6885\u68ee\u9a6c\u5409\u62c9",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 50
        },
        {
          name: "sisley\u5929\u732b",
          type: 1,
          total_project_cnt: 22,
          status: 0,
          pgc_brand_id: 51
        },
        {
          name: "\u963f\u8482\u4ed9\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 52
        },
        {
          name: "lululemon\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 53
        },
        {
          name: "\u73c2\u8482\u4e1d\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 54
        },
        {
          name: "cdf\u5029\u78a7\u591a\u5e73\u53f0",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 55
        },
        {
          name: "Lancaster\u94f6\u6cf0\u5929\u732b",
          type: 1,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 56
        },
        {
          name: "cdf AVEDA\u591a\u5e73\u53f0",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 57
        },
        {
          name: "\u8299\u4e3d\u82b3\u4e1d\u6296\u97f3",
          type: 3,
          total_project_cnt: 13,
          status: 0,
          pgc_brand_id: 58
        },
        {
          name: "3CE \u4eac\u4e1c",
          type: 2,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 59
        },
        {
          name: "3CE \u5929\u732b",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 60
        },
        {
          name: "3CE \u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 61
        },
        {
          name: "GUESS\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 62
        },
        {
          name: "\u8212\u9002\u8fbe\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 63
        },
        {
          name: "\u5c0f\u4ed9\u7096\u89c6\u9891\u53f7",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 64
        },
        {
          name: "\u5c0f\u4ed9\u7096\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 65
        },
        {
          name: "\u5c0f\u7f8e\u76d2\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 66
        },
        {
          name: "\u7406\u80a4\u6cc9\u5929\u732b\u5b50\u76f4\u64ad\u95f4",
          type: 1,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 67
        },
        {
          name: "CLB\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 68
        },
        {
          name: "\u5e15\u5c14\u739b\u4e4b\u6c34\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 69
        },
        {
          name: "\u96c5\u57f9\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 70
        },
        {
          name: "Dior\u5929\u732b",
          type: 1,
          total_project_cnt: 9,
          status: 0,
          pgc_brand_id: 71
        },
        {
          name: "\u83f2\u6d1b\u5609\u5929\u732b",
          type: 1,
          total_project_cnt: 14,
          status: 0,
          pgc_brand_id: 72
        },
        {
          name: "Dior\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 7,
          status: 0,
          pgc_brand_id: 73
        },
        {
          name: "\u4fee\u4e3d\u53ef\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 74
        },
        {
          name: "\u8587\u8bfa\u5a1c\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 76
        },
        {
          name: "\u81ea\u7136\u5802\u5929\u732b",
          type: 1,
          total_project_cnt: 7,
          status: 0,
          pgc_brand_id: 77
        },
        {
          name: "\u5a07\u5170\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 78
        },
        {
          name: "\u6dd8\u5b9d\u4e70\u83dc",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 79
        },
        {
          name: "TF\u5929\u732b",
          type: 1,
          total_project_cnt: 15,
          status: 0,
          pgc_brand_id: 80
        },
        {
          name: "cdf\u99a5\u9a6c\u5c14\u591a\u5e73\u53f0",
          type: 5,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 81
        },
        {
          name: "\u9014\u864e\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 82
        },
        {
          name: "\u963f\u91cc\u76f4\u64ad\u95f4\u642d\u5efa",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 83
        },
        {
          name: "\u8482\u4f73\u5a77\u5929\u732b",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 84
        },
        {
          name: "Chloe\u5929\u732b",
          type: 1,
          total_project_cnt: 7,
          status: 0,
          pgc_brand_id: 85
        },
        {
          name: "VAC\u68b5\u514b\u96c5\u5b9d\u5929\u732b",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 86
        },
        {
          name: "BBY\u5929\u732b",
          type: 1,
          total_project_cnt: 11,
          status: 0,
          pgc_brand_id: 87
        },
        {
          name: "\u82b1\u897f\u5b50\u811a\u672c",
          type: 1,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 88
        },
        {
          name: "\u8303\u601d\u54f2\u6296\u97f3",
          type: 3,
          total_project_cnt: 9,
          status: 0,
          pgc_brand_id: 89
        },
        {
          name: "CLB\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 90
        },
        {
          name: "ALLIE\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 91
        },
        {
          name: "\u7f8e\u56e2\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 25,
          status: 0,
          pgc_brand_id: 92
        },
        {
          name: "\u96ea\u94c1\u7eb3\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 93
        },
        {
          name: "\u6f58\u6d77\u5229\u6839\u5929\u732b",
          type: 1,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 94
        },
        {
          name: "\u5a07\u5170\u591a\u5e73\u53f0",
          type: 1,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 95
        },
        {
          name: "benefit\u8d1d\u73b2\u5983\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 96
        },
        {
          name: "\u4fee\u4e3d\u53ef\u6296\u97f3",
          type: 3,
          total_project_cnt: 16,
          status: 0,
          pgc_brand_id: 97
        },
        {
          name: "\u8212\u80a4\u4f73\u6296\u97f3",
          type: 3,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 98
        },
        {
          name: "\u81ea\u7136\u5802\u6296\u97f3",
          type: 3,
          total_project_cnt: 8,
          status: 0,
          pgc_brand_id: 99
        },
        {
          name: "babycare\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 100
        },
        {
          name: "Hourglass\u7ebf\u4e0b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 101
        },
        {
          name: "\u963f\u739b\u5c3c\u5929\u732b",
          type: 1,
          total_project_cnt: 15,
          status: 0,
          pgc_brand_id: 102
        },
        {
          name: "\u5a07\u5170\u6296\u97f3",
          type: 3,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 103
        },
        {
          name: "viking\u90ae\u8f6e\u6296\u97f3",
          type: 3,
          total_project_cnt: 36,
          status: 0,
          pgc_brand_id: 104
        },
        {
          name: "\u6f58\u591a\u62c9\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 105
        },
        {
          name: "\u676d\u5dde\u8288\u58f3-\u5929\u732b\u7f8e\u98df",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 106
        },
        {
          name: "BROOKS BROTHERS\u7eaf\u5236\u4f5c",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 107
        },
        {
          name: "\u5929\u5143\u5ba0\u7269\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 108
        },
        {
          name: "\u8fbe\u4eba\u674e\u91d1\u94ed\u6296\u97f3",
          type: 3,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 109
        },
        {
          name: "\u997f\u4e86\u4e48\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 110
        },
        {
          name: "TF\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 12,
          status: 0,
          pgc_brand_id: 111
        },
        {
          name: "Dior\u4eac\u4e1c",
          type: 2,
          total_project_cnt: 10,
          status: 0,
          pgc_brand_id: 112
        },
        {
          name: "\u767d\u8c61\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 113
        },
        {
          name: "\u58a8\u81e3",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 114
        },
        {
          name: "\u82ad\u6bd4\u6ce2\u6717\u5929\u732b",
          type: 1,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 115
        },
        {
          name: "\u767e\u8349\u5473\u6296\u97f3",
          type: 3,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 116
        },
        {
          name: "olaplex\u5929\u732b",
          type: 1,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 117
        },
        {
          name: "\u534e\u4f26\u5929\u5974\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 118
        },
        {
          name: "\u6296\u97f3\u5b98\u65b9",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 119
        },
        {
          name: "FURLA\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 120
        },
        {
          name: "\u767e\u96c0\u7f9a\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 121
        },
        {
          name: "\u5965\u4f26\u7eb3\u7d20\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 122
        },
        {
          name: "Vivo\u591a\u5e73\u53f0",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 123
        },
        {
          name: "\u6cd5\u6cab\u6eaa\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 124
        },
        {
          name: "\u739b\u4e3d\u9edb\u4f73\u6296\u97f3",
          type: 3,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 125
        },
        {
          name: "\u82b1\u897f\u5b50\u89c6\u9891\u53f7",
          type: 5,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 126
        },
        {
          name: " \u6f58\u5a77\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 127
        },
        {
          name: "Za\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 128
        },
        {
          name: "\u963f\u739b\u5c3c\u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 129
        },
        {
          name: "\u540e\u5929\u732b",
          type: 1,
          total_project_cnt: 17,
          status: 0,
          pgc_brand_id: 130
        },
        {
          name: "\u6d6a\u7434\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 131
        },
        {
          name: "\u6d6a\u7434\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 132
        },
        {
          name: "\u9189\u8c61\u7ebf\u4e0b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 133
        },
        {
          name: "coach\u6296\u97f3",
          type: 3,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 134
        },
        {
          name: "\u4f0a\u83f2\u4e39\u53cc\u5e73\u53f0",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 135
        },
        {
          name: "\u96c5\u6f3e\u6296\u97f3",
          type: 3,
          total_project_cnt: 8,
          status: 0,
          pgc_brand_id: 136
        },
        {
          name: "\u6d01\u5a77\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 137
        },
        {
          name: "\u6c64\u81e3\u500d\u5065\u5929\u732b",
          type: 1,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 138
        },
        {
          name: "\u5a07\u5170\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 7,
          status: 0,
          pgc_brand_id: 139
        },
        {
          name: "\u4f0a\u5229\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 140
        },
        {
          name: "\u6c64\u81e3\u500d\u5065\u5fae\u8d5e",
          type: 5,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 141
        },
        {
          name: "Google\u7ebf\u4e0b\u57f9\u8bad",
          type: 1,
          total_project_cnt: 12,
          status: 0,
          pgc_brand_id: 142
        },
        {
          name: "\u81ea\u7136\u5802\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 146
        },
        {
          name: "SK-II \u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 148
        },
        {
          name: "\u5c0f\u4ed9\u7096\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 149
        },
        {
          name: "\u5fa1\u91d1\u672c\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 150
        },
        {
          name: "SK-II \u4eac\u4e1c",
          type: 8,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 151
        },
        {
          name: "Olay\u767e\u8d27",
          type: 5,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 152
        },
        {
          name: "sabon\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 153
        },
        {
          name: "SENSAI\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 154
        },
        {
          name: "\u6c47\u6e90\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 155
        },
        {
          name: "\u82cf\u6cca\u5c14\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 156
        },
        {
          name: "\u82b1\u897f\u5b50\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 157
        },
        {
          name: "\u5eb7\u5982\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 158
        },
        {
          name: "GUCCI\u5929\u732b",
          type: 1,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 159
        },
        {
          name: "BELLE\u767e\u4e3d\u5929\u732b",
          type: 1,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 160
        },
        {
          name: "BELLE\u767e\u4e3d\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 161
        },
        {
          name: "BELLE\u767e\u4e3d\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 162
        },
        {
          name: "BELLE\u767e\u4e3d\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 163
        },
        {
          name: "Aesop\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 164
        },
        {
          name: "SK-II \u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 165
        },
        {
          name: "Olay\u6296\u97f3",
          type: 3,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 166
        },
        {
          name: "NARS\u767e\u8d27\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 167
        },
        {
          name: "Club Monaco\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 168
        },
        {
          name: "\u72ec\u7279\u827e\u7433\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 169
        },
        {
          name: "byredo\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 170
        },
        {
          name: "Kazoo\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 171
        },
        {
          name: "\u5361\u8bd7\u6296\u97f3",
          type: 3,
          total_project_cnt: 29,
          status: 0,
          pgc_brand_id: 172
        },
        {
          name: "\u54e5\u672c\u54c8\u6839\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 173
        },
        {
          name: "Sisley\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 9,
          status: 0,
          pgc_brand_id: 174
        },
        {
          name: "\u56fa\u7136\u5802\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 175
        },
        {
          name: "\u96c5\u8bd7\u5170\u9edb\u4eac\u4e1c\u5316\u5986\u5e08",
          type: 1,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 176
        },
        {
          name: "BottegaVeneta\u5929\u732b",
          type: 1,
          total_project_cnt: 19,
          status: 0,
          pgc_brand_id: 177
        },
        {
          name: "BottegaVeneta\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 178
        },
        {
          name: "Cible Skin\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 179
        },
        {
          name: "lexy\u591a\u5e73\u53f0",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 180
        },
        {
          name: "sabon\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 181
        },
        {
          name: "\u7f8e\u529b\u57ce\u6296\u97f3",
          type: 3,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 182
        },
        {
          name: "\u6b27\u83b1\u96c5Pro\u6296\u97f3",
          type: 3,
          total_project_cnt: 8,
          status: 0,
          pgc_brand_id: 183
        },
        {
          name: "jimmychoo\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 184
        },
        {
          name: "Cible Skin\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 185
        },
        {
          name: "\u5317\u7f8e\u89c6\u9891\u5916\u5305",
          type: 1,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 186
        },
        {
          name: "\u7f8eone\u89c6\u9891",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 187
        },
        {
          name: "\u73c2\u6da6\u5168\u5e73\u53f0",
          type: 1,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 188
        },
        {
          name: "\u975e\u9c7c\u5341\u4e00\u5c0f\u7ea2\u4e66",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 189
        },
        {
          name: "\u5176\u4ed6\u6296\u97f3",
          type: 3,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 190
        },
        {
          name: "\u60a6\u8299\u5a9e\u6296\u97f3",
          type: 3,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 191
        },
        {
          name: "\u7f8e\u8bfa\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 192
        },
        {
          name: "\u7406\u80a4\u6cc9\u6296\u97f3",
          type: 3,
          total_project_cnt: 10,
          status: 0,
          pgc_brand_id: 193
        },
        {
          name: "nodoff\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 194
        },
        {
          name: "nodoff\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 195
        },
        {
          name: "\u6bdb\u6208\u5e73\u6296\u97f3",
          type: 3,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 196
        },
        {
          name: "Sbeauty \u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 197
        },
        {
          name: "\u9175\u8272\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 198
        },
        {
          name: "\u6717\u4ed5\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 199
        },
        {
          name: "\u83f2\u65af\u66fc\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 200
        },
        {
          name: "\u963f\u8fea\u8fbe\u65af\u6d17\u62a4 \u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 201
        },
        {
          name: "diptyque\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 202
        },
        {
          name: "CPB\u6296\u97f3",
          type: 3,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 203
        },
        {
          name: "CPB\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 204
        },
        {
          name: "\u60a6\u6728\u4e4b\u6e90\u5929\u732b",
          type: 1,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 205
        },
        {
          name: "\u5b89\u5229\u96c5\u59ff\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 206
        },
        {
          name: "\u7518\u6e90\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 207
        },
        {
          name: "\u73c0\u83b1\u96c5\u6296\u97f3",
          type: 3,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 208
        },
        {
          name: "Off&Relax\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 209
        },
        {
          name: "\u5c0f\u7ea2\u4e66KOL\u77ed\u89c6\u9891",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 210
        },
        {
          name: "\u91cd\u5e86\u533b\u79d1\u5927\u5b66",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 211
        },
        {
          name: "\u6735\u68b5\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 212
        },
        {
          name: "\u6f58\u5a77\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 213
        },
        {
          name: "\u97f3\u4e50\u4f1a\u76f4\u64ad",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 214
        },
        {
          name: "\u5e2e\u5b9d\u9002\u5929\u732b",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 215
        },
        {
          name: "\u6d77\u98de\u4e1d\u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 216
        },
        {
          name: "the ordinary\u5929\u732b",
          type: 1,
          total_project_cnt: 4,
          status: 0,
          pgc_brand_id: 217
        },
        {
          name: "\u73c0\u8299\u7814\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 218
        },
        {
          name: "\u5f69\u68e0\u6296\u97f3",
          type: 3,
          total_project_cnt: 10,
          status: 0,
          pgc_brand_id: 219
        },
        {
          name: "\u79d1\u745e\u80a4\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 220
        },
        {
          name: "Sisley\u5c0f\u7ea2\u4e66",
          type: 5,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 221
        },
        {
          name: "TATA \u5929\u732b",
          type: 1,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 222
        },
        {
          name: "\u601d\u52a0\u56fe\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 223
        },
        {
          name: "NARS\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 224
        },
        {
          name: "Olay\u5929\u732b",
          type: 1,
          total_project_cnt: 5,
          status: 0,
          pgc_brand_id: 225
        },
        {
          name: "kato\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 226
        },
        {
          name: "\u4e09\u751f\u82b1\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 227
        },
        {
          name: "Charles&Keith\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 228
        },
        {
          name: "ARMANI\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 229
        },
        {
          name: "66\u5ea6\u63a2\u9669\u90ae\u8f6e\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 6,
          status: 0,
          pgc_brand_id: 230
        },
        {
          name: "H&M\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 231
        },
        {
          name: "\u56fe\u62c9\u65af\u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 232
        },
        {
          name: "\u6b27\u8bd7\u6f2b\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 233
        },
        {
          name: "\u5e2e\u5b9d\u9002\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 234
        },
        {
          name: "\u8587\u5a77&intima\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 235
        },
        {
          name: "babycare\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 236
        },
        {
          name: "Discovery\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 237
        },
        {
          name: "CPB\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 238
        },
        {
          name: "\u65bd\u534e\u853b\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 239
        },
        {
          name: "Bata\u5929\u732b",
          type: 1,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 240
        },
        {
          name: "\u4eac\u4e1c\u91c7\u95003C",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 241
        },
        {
          name: "Wacoal\u5929\u732b",
          type: 1,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 242
        },
        {
          name: "\u7f8e\u837b\u65af\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 243
        },
        {
          name: "\u592a\u5e73\u9e1f\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 244
        },
        {
          name: "MLB\u6296\u97f3",
          type: 3,
          total_project_cnt: 3,
          status: 0,
          pgc_brand_id: 245
        },
        {
          name: "\u5317\u7f8e\u77ed\u89c6\u9891",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 246
        },
        {
          name: "\u9010\u672c\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 247
        },
        {
          name: "\u79d1\u5170\u9ece\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 248
        },
        {
          name: "\u6781\u840c\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 249
        },
        {
          name: "\u81b3\u9b54\u5e08\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 250
        },
        {
          name: "\u732b\u4eba\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 251
        },
        {
          name: "\u4e09\u5143\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 252
        },
        {
          name: "\u5c0a\u5c3c\u83b7\u52a0\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 253
        },
        {
          name: "Sabon\u7ebf\u4e0b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 255
        },
        {
          name: "\u767e\u83f2\u916a\u725b\u5976\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 256
        },
        {
          name: "gucci\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 257
        },
        {
          name: "\u5ad2\u78a7\u77e5\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 258
        },
        {
          name: "\u99a5\u7eff\u5fb7\u96c5\u591a\u5e73\u53f0",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 259
        },
        {
          name: "\u6d77\u98de\u4e1d\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 260
        },
        {
          name: "\u5170\u5609\u4e1d\u6c40\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 261
        },
        {
          name: "\u7f8e\u529b\u57ce\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 262
        },
        {
          name: "\u65ed\u4e1c\u74dc\u5b50\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 263
        },
        {
          name: "\u597d\u60f3\u6765\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 264
        },
        {
          name: "\u5361\u8bd7\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 265
        },
        {
          name: "ct\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 266
        },
        {
          name: "\u8288\u58f3\u5e74\u4f1a",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 267
        },
        {
          name: "\u96cf\u83ca\u7684\u5929\u7a7a\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 268
        },
        {
          name: "fentybeauty\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 269
        },
        {
          name: "\u563b\u5546\u57ce\u5c0f\u7a0b\u5e8f",
          type: 5,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 270
        },
        {
          name: "\u5361\u8bd7\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 272
        },
        {
          name: "\u4f18\u65f6\u989c",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 273
        },
        {
          name: "\u4e5d\u9633\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 274
        },
        {
          name: "\u4f50\u5ddd\u773c\u955c\u7ebf\u4e0b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 275
        },
        {
          name: "\u79d1\u989c\u6c0f\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 276
        },
        {
          name: "EVELOM \u6296\u97f3",
          type: 3,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 277
        },
        {
          name: "\u9ea6\u5f53\u52b3\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 278
        },
        {
          name: "\u99a5\u7eff\u5fb7\u96c5\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 279
        },
        {
          name: "\u5938\u8fea\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 280
        },
        {
          name: "\u9a86\u738b\u5b87\u6296\u97f3",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 281
        },
        {
          name: "toomanyshoes\u591a\u5e73\u53f0\u540c\u63a8",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 282
        },
        {
          name: "\u534e\u4f26\u5929\u5974\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 283
        },
        {
          name: "\u6da6\u672c\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 284
        },
        {
          name: "\u8eba\u5c9b\u5929\u732b",
          type: 1,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 285
        },
        {
          name: "The Whoo \u4eac\u4e1c",
          type: 8,
          total_project_cnt: 0,
          status: 0,
          pgc_brand_id: 286
        },
        {
          name: "\u6b27\u83b1\u96c5\u7537\u58eb",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 287
        },
        {
          name: "\u6da6\u767e\u989c",
          type: 3,
          total_project_cnt: 2,
          status: 0,
          pgc_brand_id: 288
        },
        {
          name: "MADE BY MITCHELL\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 289
        },
        {
          name: "\u6e05\u626c\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 290
        },
        {
          name: "Off&Relax\u4eac\u4e1c",
          type: 8,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 291
        },
        {
          name: "Za\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 292
        },
        {
          name: "TF\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 294
        },
        {
          name: "Off&Relax\u5929\u732b",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 296
        },
        {
          name: "Makeup forever",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 297
        },
        {
          name: "\u5e15\u68ee\u5168\u5e73\u53f0",
          type: 1,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 298
        },
        {
          name: "the ordinary\u6296\u97f3",
          type: 3,
          total_project_cnt: 1,
          status: 0,
          pgc_brand_id: 299
        }
      ],
      staffs: [
        {
          name: "chengxi",
          staff_id: 49,
          all_types: [4, 3, 5, 8, 9, 10],
          email: "chengx@miicore.com",
          types: [4, 3, 5, 9, 10],
          all_ids: [49, 62, 79, 395, 439, 440]
        },
        {
          name: "chenlili",
          staff_id: 64,
          all_types: [3, 5, 8, 9, 10, 4],
          email: "chenll@miicore.com",
          types: [3, 5, 8, 9, 10, 4],
          all_ids: [64, 82, 441, 442, 443, 723]
        },
        {
          name: "lily",
          staff_id: 30,
          all_types: [3, 5, 6],
          email: "hufl@miicore.com",
          types: [3, 5, 6],
          all_ids: [30, 83, 444]
        },
        {
          name: "nihua",
          staff_id: 39,
          all_types: [4, 5, 3, 8, 10, 9],
          email: "nihua@miicore.com",
          types: [4, 8, 10, 9],
          all_ids: [39, 84, 85, 86, 209, 210]
        },
        {
          name: "\u5168\u51ac\u59ae",
          staff_id: 424,
          all_types: [4, 9, 3, 5],
          email: "dongni@miicore.com",
          types: [4, 9, 3, 5],
          all_ids: [424, 425, 459, 460]
        },
        {
          name: "\u51af\u9759",
          staff_id: 13,
          all_types: [3, 4, 6, 9, 5],
          email: "fengj@miicore.com",
          types: [3, 4, 6, 9, 5],
          all_ids: [13, 184, 185, 186, 211]
        },
        {
          name: "\u5218\u53cc",
          staff_id: 640,
          all_types: [1, 12, 4],
          email: "liushuang@miicore.com",
          types: [1, 12, 4],
          all_ids: [640, 641, 644]
        },
        {
          name: "\u5218\u6210\u7537",
          staff_id: 128,
          all_types: [4, 5, 3, 10, 9, 1],
          email: "nomiliu@miicore.com",
          types: [4, 5, 3, 10, 9, 1],
          all_ids: [128, 129, 130, 212, 213, 445]
        },
        {
          name: "\u5218\u6587\u5a1f",
          staff_id: 2,
          all_types: [1, 7, 10, 8, 9, 6, 12],
          email: "liuwj@miicore.com",
          types: [1, 7, 10, 8, 9, 6, 12],
          all_ids: [2, 90, 318, 319, 320, 321, 560]
        },
        {
          name: "\u5218\u6615",
          staff_id: 576,
          all_types: [4, 3, 5],
          email: "",
          types: [4, 3, 5],
          all_ids: [576, 577, 578]
        },
        {
          name: "\u5218\u661f\u96e8",
          staff_id: 838,
          all_types: [4, 9],
          email: "",
          types: [4, 9],
          all_ids: [838, 839]
        },
        {
          name: "\u5218\u6676\u6676",
          staff_id: 75,
          all_types: [4, 6, 8, 3, 10, 5, 9, 11],
          email: "jingjing@miicore.com",
          types: [4, 8, 3, 10, 5, 9, 11],
          all_ids: [75, 76, 80, 214, 215, 216, 217, 727]
        },
        {
          name: "\u5218\u672c\u5168",
          staff_id: 849,
          all_types: [9, 8],
          email: "benquan@miicore.com",
          types: [9, 8],
          all_ids: [849, 850]
        },
        {
          name: "\u5218\u7d2b\u8431",
          staff_id: 832,
          all_types: [2, 10, 9],
          email: "",
          types: [2, 10],
          all_ids: [832, 833, 834]
        },
        {
          name: "\u5218\u96e8\u6674",
          staff_id: 38,
          all_types: [2, 6, 10],
          email: "estherliu@miicore.com",
          types: [2, 6, 10],
          all_ids: [38, 95, 163]
        },
        {
          name: "\u5218\u9896",
          staff_id: 736,
          all_types: [1, 12, 6],
          email: "",
          types: [1, 12, 6],
          all_ids: [736, 737, 738]
        },
        {
          name: "\u52b3\u7a0b\u9633",
          staff_id: 205,
          all_types: [8, 10, 9],
          email: "chengyang@miicore.com",
          types: [8, 10, 9],
          all_ids: [205, 227, 228]
        },
        {
          name: "\u5317\u4eac\u6797\u4e50\u5ba3",
          staff_id: 360,
          all_types: [6, 1, 7, 4, 9, 10, 2],
          email: "",
          types: [1, 7, 4, 9, 10, 2],
          all_ids: [360, 361, 362, 363, 388, 389, 446]
        },
        {
          name: "\u5362\u8d85\u660e",
          staff_id: 808,
          all_types: [6, 1, 12, 7],
          email: "",
          types: [6, 1, 12, 7],
          all_ids: [808, 809, 810, 811]
        },
        {
          name: "\u53f6\u53ef\u6b23",
          staff_id: 804,
          all_types: [9, 8, 10, 6],
          email: "ykxin@miicore.com",
          types: [9, 8, 10],
          all_ids: [804, 805, 806, 807]
        },
        {
          name: "\u5411\u96c5\u4e3d",
          staff_id: 131,
          all_types: [8, 10, 9, 4],
          email: "nicolexiang@miicore.com",
          types: [8, 10, 9],
          all_ids: [131, 218, 219, 303]
        },
        {
          name: "\u5434\u4e16\u6770",
          staff_id: 710,
          all_types: [1, 12, 6, 7],
          email: "wshijie@miicore.com",
          types: [1, 12, 6, 7],
          all_ids: [710, 711, 712, 713]
        },
        {
          name: "\u5434\u51ef",
          staff_id: 198,
          all_types: [8, 10, 9, 4],
          email: "wukai@miicore.com",
          types: [8, 10, 9, 4],
          all_ids: [198, 220, 221, 348]
        },
        {
          name: "\u5434\u78ca",
          staff_id: 162,
          all_types: [10, 9, 3, 5, 11],
          email: "wulei@miicore.com",
          types: [10, 9],
          all_ids: [162, 175, 842, 843, 880]
        },
        {
          name: "\u5468\u4e50\u8587",
          staff_id: 724,
          all_types: [9, 11],
          email: "leweizhou@miicore.com",
          types: [9, 11],
          all_ids: [724, 725]
        },
        {
          name: "\u5468\u60e0",
          staff_id: 541,
          all_types: [4, 9, 10, 8],
          email: "zhouhui@miicore.com",
          types: [4, 9],
          all_ids: [541, 556, 557, 558]
        },
        {
          name: "\u59da\u6c38\u536b\uff08\u6280\u672f\u603b\u76d1\uff09",
          staff_id: 550,
          all_types: [7, 1, 9, 6],
          email: "yongwei@miicore.com",
          types: [7, 1],
          all_ids: [550, 551, 827, 828]
        },
        {
          name: "\u5b59\u5b8f\u5409",
          staff_id: 530,
          all_types: [3, 5, 7, 4, 6, 9, 10, 11, 8],
          email: "hongji@miicore.com",
          types: [3, 5, 4, 6, 9, 10, 11, 8],
          all_ids: [530, 531, 596, 597, 598, 599, 771, 772, 773]
        },
        {
          name: "\u5b89\u601d\u540d",
          staff_id: 479,
          all_types: [4, 9, 10, 3, 5],
          email: "siming@miicore.com",
          types: [4, 9, 10, 3, 5],
          all_ids: [479, 480, 481, 482, 483]
        },
        {
          name: "\u5b89\u7f57\u5170",
          staff_id: 612,
          all_types: [9, 8, 10, 4],
          email: "luolan@miicore.com",
          types: [9, 8, 10, 4],
          all_ids: [612, 613, 614, 756]
        },
        {
          name: "\u5b8b\u5fc5\u626c",
          staff_id: 665,
          all_types: [5, 6, 4, 9, 11, 8, 7, 1, 12, 2, 3, 10],
          email: "songbiyang@miicore.com",
          types: [5, 3],
          all_ids: [665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676]
        },
        {
          name: "\u5b8b\u6cfd\u6590",
          staff_id: 199,
          all_types: [8, 10, 9, 4, 5, 3],
          email: "songzf@miicore.com",
          types: [8, 10, 9, 4, 5, 3],
          all_ids: [199, 232, 233, 412, 762, 763]
        },
        {
          name: "\u5d47\u794e\u73ae",
          staff_id: 658,
          all_types: [4, 9, 8, 10],
          email: "jesscence@miicore.com",
          types: [4, 9, 8, 10],
          all_ids: [658, 659, 660, 661]
        },
        {
          name: "\u5de9\u4e3d\u73e0",
          staff_id: 593,
          all_types: [2, 10, 6],
          email: "gonglz@miicore.com",
          types: [2, 10, 6],
          all_ids: [593, 594, 595]
        },
        {
          name: "\u5e94\u96ef\u742a",
          staff_id: 372,
          all_types: [4, 6, 8, 10, 9, 5, 3, 7, 2],
          email: "vickiying@miicore.com",
          types: [4, 6, 8, 10, 9, 5, 3, 7, 2],
          all_ids: [372, 373, 374, 375, 376, 487, 488, 742, 744]
        },
        {
          name: "\u5ed6\u5609\u94b0",
          staff_id: 36,
          all_types: [1, 2, 7, 10, 9, 12],
          email: "liaojy@miicore.com",
          types: [1, 7, 9, 12],
          all_ids: [36, 72, 91, 164, 410, 561]
        },
        {
          name: "\u5f20\u51ef\u4eae",
          staff_id: 726,
          all_types: [4, 9],
          email: "kailiang@miicore.com",
          types: [4],
          all_ids: [726, 862]
        },
        {
          name: "\u5f20\u58eb\u68ee",
          staff_id: 718,
          all_types: [8, 9, 10, 11],
          email: "",
          types: [8, 9, 10, 11],
          all_ids: [718, 719, 720, 721]
        },
        {
          name: "\u5f20\u65ed",
          staff_id: 600,
          all_types: [2, 6, 10],
          email: "zhangxu@miicore.com",
          types: [2, 6, 10],
          all_ids: [600, 601, 602]
        },
        {
          name: "\u5f20\u667a",
          staff_id: 12,
          all_types: [3, 4, 6, 5, 10],
          email: "zhangz@miicore.com",
          types: [3, 4, 5],
          all_ids: [12, 67, 96, 97, 172]
        },
        {
          name: "\u5f20\u971e",
          staff_id: 405,
          all_types: [4, 8, 9, 10],
          email: "zhangxia@miicore.com",
          types: [8, 9, 10],
          all_ids: [405, 413, 434, 435]
        },
        {
          name: "\u5f90\u5de7\u5de7",
          staff_id: 844,
          all_types: [10, 9, 8],
          email: "xuqiaoqiao@miicore.com",
          types: [10, 9, 8],
          all_ids: [844, 845, 846]
        },
        {
          name: "\u5f90\u6653\u6db5",
          staff_id: 463,
          all_types: [3, 4, 5, 6],
          email: "xuxh@miicore.com",
          types: [3, 4, 5, 6],
          all_ids: [463, 464, 465, 466]
        },
        {
          name: "\u63ed\u96e8\u65cb",
          staff_id: 333,
          all_types: [2, 10, 6, 9],
          email: "yuxuan@miicore.com",
          types: [2, 10, 6, 9],
          all_ids: [333, 334, 338, 538]
        },
        {
          name: "\u65b9\u6cfd\u5f6c\uff08\u4e2d\u7ea7\uff09",
          staff_id: 378,
          all_types: [1, 7],
          email: "zebin@miicore.com",
          types: [1, 7],
          all_ids: [378, 379]
        },
        {
          name: "\u65b9\u742a\u742a",
          staff_id: 824,
          all_types: [4, 9],
          email: "qiqifang@miicore.com",
          types: [4, 9],
          all_ids: [824, 826]
        },
        {
          name: "\u6613\u5065\u534e",
          staff_id: 706,
          all_types: [1, 12, 6, 7],
          email: "jianhua@miicore.com",
          types: [1, 12, 6, 7],
          all_ids: [706, 707, 708, 709]
        },
        {
          name: "\u664f\u5bd2",
          staff_id: 194,
          all_types: [8, 10, 9, 4, 5, 3],
          email: "yanhan@miicore.com",
          types: [8, 10, 9, 4, 5, 3],
          all_ids: [194, 246, 247, 398, 620, 621]
        },
        {
          name: "\u6731\u6021\u6587",
          staff_id: 37,
          all_types: [2, 6, 10],
          email: "amorzhu@miicore.com",
          types: [2, 6, 10],
          all_ids: [37, 100, 167]
        },
        {
          name: "\u6731\u96e8\u6770",
          staff_id: 787,
          all_types: [1, 6, 12, 7],
          email: "yujie@miicore.com",
          types: [1, 6, 12, 7],
          all_ids: [787, 788, 789, 790]
        },
        {
          name: "\u674e\u5c11\u8f69",
          staff_id: 202,
          all_types: [8, 10, 9, 4, 5, 3],
          email: "shaoxuan@miicore.com",
          types: [8, 10, 9, 4, 5, 3],
          all_ids: [202, 254, 255, 399, 580, 581]
        },
        {
          name: "\u674e\u7389",
          staff_id: 829,
          all_types: [3, 5, 4],
          email: "liyu@miicore.com",
          types: [3, 5, 4],
          all_ids: [829, 830, 831]
        },
        {
          name: "\u674e\u827a",
          staff_id: 71,
          all_types: [4, 5, 3, 10, 9, 8],
          email: "amandali@miicore.com",
          types: [4, 5, 3, 10, 9, 8],
          all_ids: [71, 77, 102, 256, 257, 447]
        },
        {
          name: "\u674e\u9e3f\u98de",
          staff_id: 732,
          all_types: [8, 9, 10, 11],
          email: "",
          types: [8, 9, 10, 11],
          all_ids: [732, 733, 734, 735]
        },
        {
          name: "\u675c\u5c0f\u840d",
          staff_id: 6,
          all_types: [2, 6, 10],
          email: "sofiadu@miicore.com",
          types: [2, 6, 10],
          all_ids: [6, 103, 168]
        },
        {
          name: "\u675c\u6c38\u8d24\uff08\u9ad8\u7ea7\uff09",
          staff_id: 304,
          all_types: [7, 1, 6, 12, 2, 4, 9],
          email: "yongxian@miicore.com",
          types: [7, 1, 6, 12, 2, 4, 9],
          all_ids: [304, 305, 326, 559, 687, 688, 689]
        },
        {
          name: "\u6768\u97eb\u5b87",
          staff_id: 535,
          all_types: [1, 9, 4, 12],
          email: "yangyangyang@miicore.com",
          types: [1, 9, 4, 12],
          all_ids: [535, 548, 549, 631]
        },
        {
          name: "\u6797\u68a8\u7ea2",
          staff_id: 791,
          all_types: [4, 8, 10, 9, 11],
          email: "",
          types: [4, 8, 10, 9, 11],
          all_ids: [791, 792, 793, 794, 795]
        },
        {
          name: "\u6bb5\u5e05\u51ef",
          staff_id: 582,
          all_types: [10, 8, 9, 4],
          email: "shuaikai@miicore.com",
          types: [10, 8, 9, 4],
          all_ids: [582, 583, 584, 699]
        },
        {
          name: "\u6c88\u633a\uff08\u9ad8\u7ea7\uff09",
          staff_id: 306,
          all_types: [1, 7, 6, 12],
          email: "shentin@miicore.com",
          types: [1, 7, 6, 12],
          all_ids: [306, 307, 325, 728]
        },
        {
          name: "\u6e29\u4e3d\u5a77",
          staff_id: 700,
          all_types: [9, 8, 11, 10],
          email: "litin@miicore.com",
          types: [9, 8],
          all_ids: [700, 701, 749, 750]
        },
        {
          name: "\u718a\u73ae",
          staff_id: 796,
          all_types: [12, 6, 1],
          email: "",
          types: [12, 6, 1],
          all_ids: [796, 797, 798]
        },
        {
          name: "\u718a\u73b2",
          staff_id: 14,
          all_types: [3, 4, 6, 5, 10, 9],
          email: "xiongl@miicore.com",
          types: [3, 4, 5, 10, 9],
          all_ids: [14, 70, 104, 105, 268, 269]
        },
        {
          name: "\u738b\u4f73\u660e\uff08\u9ad8\u7ea7\uff09",
          staff_id: 322,
          all_types: [7, 6, 1, 12, 2, 4, 9],
          email: "jiaming@miicore.com",
          types: [7, 6, 1, 12, 2, 4, 9],
          all_ids: [322, 323, 324, 686, 690, 691, 692]
        },
        {
          name: "\u738b\u51ef\u5a77",
          staff_id: 825,
          all_types: [9, 4, 3, 5],
          email: "kaitin@miicore.com",
          types: [9, 4],
          all_ids: [825, 835, 855, 856]
        },
        {
          name: "\u738b\u53ef\u6b23",
          staff_id: 191,
          all_types: [8, 10, 9],
          email: "kexin@miicore.com",
          types: [8, 10, 9],
          all_ids: [191, 270, 271]
        },
        {
          name: "\u738b\u58eb\u9a8f",
          staff_id: 634,
          all_types: [12, 7, 1],
          email: "shijun@miicore.com",
          types: [12, 7, 1],
          all_ids: [634, 635, 636]
        },
        {
          name: "\u738b\u5e78\u745c",
          staff_id: 745,
          all_types: [4, 10, 9, 11],
          email: "wangxingyu@miicore.com",
          types: [4, 10, 9, 11],
          all_ids: [745, 746, 747, 748]
        },
        {
          name: "\u738b\u76db\u5170",
          staff_id: 145,
          all_types: [2, 10, 6],
          email: "kikowang@miicore.com",
          types: [2, 10, 6],
          all_ids: [145, 170, 272]
        },
        {
          name: "\u738b\u7aef\u80dc",
          staff_id: 540,
          all_types: [2],
          email: "duansheng@miicore.com",
          types: [2],
          all_ids: [540]
        },
        {
          name: "\u738b\u806a\u9896",
          staff_id: 815,
          all_types: [1, 12, 7],
          email: "congying@miicore.com",
          types: [1, 12, 7],
          all_ids: [815, 816, 817]
        },
        {
          name: "\u738b\u8bd7\u4e91",
          staff_id: 396,
          all_types: [9, 8, 10, 4],
          email: "shiyun@miicore.com",
          types: [9, 8, 10],
          all_ids: [396, 448, 449, 516]
        },
        {
          name: "\u767d\u6167\u73b2",
          staff_id: 627,
          all_types: [9],
          email: "huilingbai@dingtalk.com",
          types: [9],
          all_ids: [627]
        },
        {
          name: "\u7f57\u79cb\u6708",
          staff_id: 10,
          all_types: [2, 6, 10, 9],
          email: "luoqy@miicore.com",
          types: [2, 6, 10],
          all_ids: [10, 111, 171, 898]
        },
        {
          name: "\u80e1\u5409\u4e3d",
          staff_id: 133,
          all_types: [3, 5, 4, 10, 9],
          email: "laviehu@miicore.com",
          types: [3, 5, 4, 9],
          all_ids: [133, 134, 135, 161, 275]
        },
        {
          name: "\u8212\u7434AE",
          staff_id: 44,
          all_types: [4, 8, 3, 10, 5, 9],
          email: "shuq@miicore.com",
          types: [4, 8, 3, 10, 5, 9],
          all_ids: [44, 60, 276, 277, 278, 279]
        },
        {
          name: "\u8303\u5bb6\u5947",
          staff_id: 365,
          all_types: [7, 1, 6],
          email: "jiaqi@miicore.com",
          types: [7, 1],
          all_ids: [365, 366, 369]
        },
        {
          name: "\u8463\u66cc",
          staff_id: 1,
          all_types: [1, 7, 9, 12],
          email: "",
          types: [1, 7, 9, 12],
          all_ids: [1, 112, 423, 566]
        },
        {
          name: "\u848b\u6743",
          staff_id: 585,
          all_types: [8, 10, 9],
          email: "jiangquan@miicore.com",
          types: [8, 10, 9],
          all_ids: [585, 586, 587]
        },
        {
          name: "\u8521\u5bb6\u7433",
          staff_id: 18,
          all_types: [3, 4, 5, 10, 9],
          email: "caijl@miicore.com",
          types: [3, 4, 5],
          all_ids: [18, 40, 59, 928, 929]
        },
        {
          name: "\u8bb8\u4e00\u51e1",
          staff_id: 702,
          all_types: [1, 12, 6, 7],
          email: "yifan@miicore.com",
          types: [1, 12, 6, 7],
          all_ids: [702, 703, 704, 705]
        },
        {
          name: "\u8c22\u5168",
          staff_id: 196,
          all_types: [8, 10, 9],
          email: "xiequan@miicore.com",
          types: [8, 10, 9],
          all_ids: [196, 284, 285]
        },
        {
          name: "\u8c22\u6668\u857e",
          staff_id: 775,
          all_types: [2, 10, 6, 9],
          email: "chenlei@miicore.com",
          types: [2, 10, 6, 9],
          all_ids: [775, 776, 777, 778]
        },
        {
          name: "\u8c22\u9732\u4e91",
          staff_id: 836,
          all_types: [4, 9, 5, 10],
          email: "luyun@miicore.com",
          types: [4, 9],
          all_ids: [836, 837, 919, 920]
        },
        {
          name: "\u8d3a\u4f73\u6770",
          staff_id: 35,
          all_types: [3, 5, 4, 9, 10],
          email: "hejj@miicore.com",
          types: [3, 5, 4, 9],
          all_ids: [35, 114, 286, 394, 517]
        },
        {
          name: "\u8d3e\u6d77\u519b",
          staff_id: 192,
          all_types: [8, 10, 9, 4],
          email: "haijun@miicore.com",
          types: [8, 10, 9, 4],
          all_ids: [192, 287, 288, 501]
        },
        {
          name: "\u8d75\u946b\u6e90",
          staff_id: 15,
          all_types: [3, 4, 5, 10, 9],
          email: "",
          types: [3, 4, 5, 10, 9],
          all_ids: [15, 47, 115, 289, 290]
        },
        {
          name: "\u90dd\u6674",
          staff_id: 628,
          all_types: [4, 3, 5, 8, 9, 11],
          email: "khaleesi@miicore.com",
          types: [4, 3, 5, 8, 9, 11],
          all_ids: [628, 730, 731, 847, 848, 851]
        },
        {
          name: "\u90dd\u9753",
          staff_id: 542,
          all_types: [9, 8, 10],
          email: "haojing@miicore.com",
          types: [9, 8],
          all_ids: [542, 543, 921]
        },
        {
          name: "\u90ed\u6770",
          staff_id: 201,
          all_types: [8, 10, 9, 4, 3],
          email: "guojie@miicore.com",
          types: [8, 10, 9, 4],
          all_ids: [201, 295, 296, 393, 622]
        },
        {
          name: "\u90ed\u78ca",
          staff_id: 821,
          all_types: [9, 8, 10, 4],
          email: "guolei@miicore.com",
          types: [9, 8, 10],
          all_ids: [821, 822, 823, 889]
        },
        {
          name: "\u90ed\u7ade\u7f8e",
          staff_id: 154,
          all_types: [6, 8, 9, 10, 7, 4],
          email: "guojm@miicore.com",
          types: [8, 9, 10, 4],
          all_ids: [154, 155, 156, 157, 158, 159]
        },
        {
          name: "\u91d1\u4f73\u6d0b",
          staff_id: 609,
          all_types: [10, 8, 9, 4, 3, 5],
          email: "jiayang@miicore.com",
          types: [10, 8, 9, 4, 3, 5],
          all_ids: [609, 610, 611, 755, 802, 803]
        },
        {
          name: "\u91d1\u5a9b\u7f8e",
          staff_id: 197,
          all_types: [8, 10, 9, 4],
          email: "jinym@miicore.com",
          types: [8, 10, 9],
          all_ids: [197, 297, 298, 913]
        },
        {
          name: "\u91d1\u6653\u94b0",
          staff_id: 121,
          all_types: [2, 10, 6, 4, 9, 5, 3, 8, 7],
          email: "jinni@miicore.com",
          types: [2, 10, 6, 4, 9, 5, 3, 8, 7],
          all_ids: [121, 173, 188, 308, 309, 409, 411, 453, 743]
        },
        {
          name: "\u9633\u6c76\u5a77",
          staff_id: 567,
          all_types: [9, 8, 10, 4],
          email: "valora@miicore.com",
          types: [9, 8, 10, 4],
          all_ids: [567, 568, 569, 774]
        },
        {
          name: "\u9a6c\u8389",
          staff_id: 500,
          all_types: [9, 11, 10, 4],
          email: "mali@miicore.com",
          types: [9, 11, 10, 4],
          all_ids: [500, 513, 527, 552]
        },
        {
          name: "\u9b4f\u709c",
          staff_id: 521,
          all_types: [2, 10, 6],
          email: "weiwei@miicore.com",
          types: [2, 10, 6],
          all_ids: [521, 522, 523]
        },
        {
          name: "\u9b4f\u7433\u835f",
          staff_id: 327,
          all_types: [2, 10, 6],
          email: "linhui@miicore.com",
          types: [2, 10, 6],
          all_ids: [327, 328, 335]
        },
        {
          name: "\u9ec4\u4e88\u6b23",
          staff_id: 331,
          all_types: [2, 10, 6],
          email: "yuxin@miicore.com",
          types: [2, 10, 6],
          all_ids: [331, 332, 337]
        },
        {
          name: "\u9ec4\u627f\u53d1",
          staff_id: 632,
          all_types: [9, 8, 10, 4],
          email: "chengfa@miicore.com",
          types: [9, 8, 10],
          all_ids: [632, 677, 678, 885]
        },
        {
          name: "\u9ec4\u661f\u4f1f",
          staff_id: 489,
          all_types: [1, 12, 9, 4],
          email: "xingwei@miicore.com",
          types: [1, 12, 9, 4],
          all_ids: [489, 539, 546, 547]
        },
        {
          name: "\u9ec4\u6dfb\u5b87",
          staff_id: 714,
          all_types: [8, 9, 10, 11],
          email: "tianyu@miicore.com",
          types: [8, 9, 10, 11],
          all_ids: [714, 715, 716, 717]
        },
        {
          name: "\u9ece\u68a6\u5a55",
          staff_id: 840,
          all_types: [9, 8],
          email: "",
          types: [9, 8],
          all_ids: [840, 841]
        },
        {
          name: "Eason",
          staff_id: 370,
          all_types: [7, 1, 5, 3, 4, 10, 6, 12, 9, 11, 8, 2],
          email: "eason.mc@miicore.com",
          types: [],
          all_ids: [370, 371, 615, 616, 779, 780, 781, 782, 783, 784, 785, 786]
        },
        {
          name: "caijialin",
          staff_id: 61,
          all_types: [3, 5],
          email: "",
          types: [],
          all_ids: [61, 74]
        },
        {
          name: "caozihan",
          staff_id: 58,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [58]
        },
        {
          name: "chengyulin",
          staff_id: 48,
          all_types: [4, 3, 5],
          email: "",
          types: [],
          all_ids: [48, 63, 81]
        },
        {
          name: "chloeliu",
          staff_id: 863,
          all_types: [3, 4, 5, 8, 9, 10, 11],
          email: "chloeliu@miicore.com",
          types: [],
          all_ids: [863, 864, 865, 876, 877, 878, 879]
        },
        {
          name: "flora",
          staff_id: 866,
          all_types: [4],
          email: "flora.chen@miicore.com",
          types: [],
          all_ids: [866]
        },
        {
          name: "lijunya",
          staff_id: 53,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [53]
        },
        {
          name: "ruanshi",
          staff_id: 43,
          all_types: [4, 3],
          email: "",
          types: [],
          all_ids: [43, 125]
        },
        {
          name: "sunzhaolu",
          staff_id: 54,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [54]
        },
        {
          name: "yuting",
          staff_id: 42,
          all_types: [4, 5, 8, 3],
          email: "",
          types: [],
          all_ids: [42, 87, 88, 117]
        },
        {
          name: "zhuhongxia",
          staff_id: 57,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [57]
        },
        {
          name: "\u4e01\u987a",
          staff_id: 3,
          all_types: [1, 7],
          email: "",
          types: [],
          all_ids: [3, 89]
        },
        {
          name: "\u4e25\u7d20\u5a77",
          staff_id: 544,
          all_types: [9, 8],
          email: "",
          types: [],
          all_ids: [544, 545]
        },
        {
          name: "\u4efb\u9038\u5609\uff08\u521d\u7ea7\uff09",
          staff_id: 384,
          all_types: [1, 7],
          email: "",
          types: [],
          all_ids: [384, 385]
        },
        {
          name: "\u4f59\u5a77",
          staff_id: 16,
          all_types: [3, 4, 9],
          email: "",
          types: [],
          all_ids: [16, 65, 176]
        },
        {
          name: "\u4faf\u51ef\u4ec1",
          staff_id: 344,
          all_types: [4, 8, 9, 10],
          email: "",
          types: [],
          all_ids: [344, 345, 346, 347]
        },
        {
          name: "\u4fde\u4e50\u6d0b",
          staff_id: 909,
          all_types: [9, 11, 10],
          email: "",
          types: [],
          all_ids: [909, 914, 915]
        },
        {
          name: "\u502a\u534e",
          staff_id: 22,
          all_types: [3, 4],
          email: "",
          types: [],
          all_ids: [22, 66]
        },
        {
          name: "\u5168\u4e1c\u59ae",
          staff_id: 457,
          all_types: [3, 5],
          email: "",
          types: [],
          all_ids: [457, 458]
        },
        {
          name: "\u51af\u5f69\u5b81",
          staff_id: 7,
          all_types: [2],
          email: "",
          types: [],
          all_ids: [7]
        },
        {
          name: "\u5218\u6653\u7389\u5029",
          staff_id: 329,
          all_types: [2, 10, 6, 8],
          email: "",
          types: [],
          all_ids: [329, 330, 336, 619]
        },
        {
          name: "\u5218\u6b23",
          staff_id: 193,
          all_types: [8, 3, 10, 5, 9, 4],
          email: "",
          types: [],
          all_ids: [193, 222, 223, 224, 225, 226]
        },
        {
          name: "\u5218\u6cfd\u8f89",
          staff_id: 532,
          all_types: [10, 9, 8],
          email: "",
          types: [],
          all_ids: [532, 533, 722]
        },
        {
          name: "\u5218\u73ca\u73ca",
          staff_id: 871,
          all_types: [9, 8, 10, 4, 11],
          email: "",
          types: [],
          all_ids: [871, 872, 873, 874, 875]
        },
        {
          name: "\u5362\u8c28",
          staff_id: 899,
          all_types: [4, 9, 6, 11, 5, 3, 10, 8],
          email: "lujin@miicore.com",
          types: [],
          all_ids: [899, 900, 901, 902, 903, 904, 905, 906]
        },
        {
          name: "\u53e4\u82ae\u5ddd",
          staff_id: 930,
          all_types: [1, 12, 6],
          email: "ruichuan.gu@miicore.com",
          types: [],
          all_ids: [930, 931, 932]
        },
        {
          name: "\u53f6\u857e",
          staff_id: 312,
          all_types: [3, 5, 4],
          email: "",
          types: [],
          all_ids: [312, 313, 314]
        },
        {
          name: "\u5415\u9526\u971e",
          staff_id: 867,
          all_types: [4, 8, 9, 10],
          email: "jinxia.lv@miicore.com",
          types: [],
          all_ids: [867, 868, 869, 870]
        },
        {
          name: "\u5434\u598d",
          staff_id: 349,
          all_types: [4, 9, 6, 3, 10, 5, 8, 1, 2],
          email: "",
          types: [],
          all_ids: [349, 350, 351, 352, 353, 354, 377, 390, 391]
        },
        {
          name: "\u5434\u5f66\u59ae",
          staff_id: 147,
          all_types: [4, 5, 3, 6, 10, 8, 9],
          email: "",
          types: [],
          all_ids: [147, 148, 149, 229, 315, 316, 317]
        },
        {
          name: "\u5434\u6653\u73e0",
          staff_id: 693,
          all_types: [9, 11, 8, 10],
          email: "",
          types: [],
          all_ids: [693, 694, 695, 696]
        },
        {
          name: "\u5468\u5723\u535a",
          staff_id: 206,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [206, 230, 231]
        },
        {
          name: "\u5468\u9e4f\uff08\u9ad8\u7ea7\uff09",
          staff_id: 386,
          all_types: [1, 7],
          email: "",
          types: [],
          all_ids: [386, 387]
        },
        {
          name: "\u59da\u51ef\uff08\u9ad8\u7ea7\uff09",
          staff_id: 118,
          all_types: [7, 1],
          email: "",
          types: [],
          all_ids: [118, 179]
        },
        {
          name: "\u5b59\u5146\u9646",
          staff_id: 20,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [20]
        },
        {
          name: "\u5b59\u9633\u6d69",
          staff_id: 606,
          all_types: [1, 6, 7],
          email: "",
          types: [],
          all_ids: [606, 607, 608]
        },
        {
          name: "\u5b59\u9633\u6d69\uff08\u521d\u7ea7\u7f16\u5bfc\uff09",
          staff_id: 588,
          all_types: [8, 7, 12],
          email: "",
          types: [],
          all_ids: [588, 589, 590]
        },
        {
          name: "\u5b5f\u7965\u6167",
          staff_id: 759,
          all_types: [4, 5, 3],
          email: "",
          types: [],
          all_ids: [759, 760, 761]
        },
        {
          name: "\u5ed6\u6cfd\u534e\uff08\u4e2d\u7ea7\u7f16\u5bfc\uff09",
          staff_id: 591,
          all_types: [7, 12],
          email: "",
          types: [],
          all_ids: [591, 592]
        },
        {
          name: "\u5f20\u4e30\u6da6",
          staff_id: 857,
          all_types: [10, 6, 2, 9, 7],
          email: "fengrun.zhang@miicore.com",
          types: [],
          all_ids: [857, 858, 859, 860, 861]
        },
        {
          name: "\u5f20\u5f3a",
          staff_id: 200,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [200, 234, 235]
        },
        {
          name: "\u5f20\u654f\u6770",
          staff_id: 4,
          all_types: [2, 6, 5, 4, 3, 10, 9],
          email: "",
          types: [],
          all_ids: [4, 92, 93, 94, 116, 165, 236]
        },
        {
          name: "\u5f20\u660a\u7389",
          staff_id: 146,
          all_types: [2, 10, 6],
          email: "",
          types: [],
          all_ids: [146, 166, 237]
        },
        {
          name: "\u5f20\u6b23\u777f",
          staff_id: 507,
          all_types: [2, 6, 10],
          email: "",
          types: [],
          all_ids: [507, 508, 509]
        },
        {
          name: "\u5f20\u6f20",
          staff_id: 504,
          all_types: [2, 6, 10],
          email: "",
          types: [],
          all_ids: [504, 505, 506]
        },
        {
          name: "\u5f20\u708e",
          staff_id: 818,
          all_types: [1, 12, 7],
          email: "",
          types: [],
          all_ids: [818, 819, 820]
        },
        {
          name: "\u5f20\u71d5\u5561",
          staff_id: 922,
          all_types: [10, 8, 9],
          email: "yanfei@miicore.com",
          types: [],
          all_ids: [922, 923, 924]
        },
        {
          name: "\u5f20\u7433",
          staff_id: 17,
          all_types: [3, 5, 6, 4, 10, 9],
          email: "",
          types: [],
          all_ids: [17, 68, 98, 99, 238, 239]
        },
        {
          name: "\u5f20\u79cb\u96e8",
          staff_id: 739,
          all_types: [1, 12, 6],
          email: "",
          types: [],
          all_ids: [739, 740, 741]
        },
        {
          name: "\u5f20\u7eee\u7eb9",
          staff_id: 510,
          all_types: [2, 6, 10],
          email: "",
          types: [],
          all_ids: [510, 511, 512]
        },
        {
          name: "\u5f20\u854a",
          staff_id: 518,
          all_types: [2, 10, 6],
          email: "",
          types: [],
          all_ids: [518, 519, 520]
        },
        {
          name: "\u5f20\u8bd7\u5a77",
          staff_id: 461,
          all_types: [4, 9, 3, 5],
          email: "",
          types: [],
          all_ids: [461, 462, 502, 503]
        },
        {
          name: "\u5f20\u96e8",
          staff_id: 132,
          all_types: [8, 10, 4, 9],
          email: "",
          types: [],
          all_ids: [132, 240, 241, 242]
        },
        {
          name: "\u5f20\u9896\u857e",
          staff_id: 430,
          all_types: [4, 9, 10, 8],
          email: "",
          types: [],
          all_ids: [430, 431, 432, 433]
        },
        {
          name: "\u5f52\u8096\u82f1",
          staff_id: 400,
          all_types: [4, 10, 9, 8],
          email: "",
          types: [],
          all_ids: [400, 406, 407, 408]
        },
        {
          name: "\u5f90\u601d\u5b81",
          staff_id: 649,
          all_types: [4, 9, 8, 10],
          email: "",
          types: [],
          all_ids: [649, 650, 651, 652]
        },
        {
          name: "\u5f90\u6653\u51e4",
          staff_id: 32,
          all_types: [3, 5, 6, 4, 9],
          email: "",
          types: [],
          all_ids: [32, 187, 243, 244, 245]
        },
        {
          name: "\u5f90\u741b",
          staff_id: 925,
          all_types: [9, 10, 8],
          email: "xuchen@miicore.com",
          types: [],
          all_ids: [925, 926, 927]
        },
        {
          name: "\u6295\u5e01",
          staff_id: 55,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [55]
        },
        {
          name: "\u65b9\u529b\u60e0\u5b50",
          staff_id: 646,
          all_types: [4, 9, 8, 10],
          email: "",
          types: [],
          all_ids: [646, 647, 648, 653]
        },
        {
          name: "\u65bd\u4f73\u745c",
          staff_id: 637,
          all_types: [10, 9, 8],
          email: "",
          types: [],
          all_ids: [637, 638, 639]
        },
        {
          name: "\u6613\u5065\u534e\uff08\u4e2d\u7ea7\uff09",
          staff_id: 382,
          all_types: [1, 7],
          email: "",
          types: [],
          all_ids: [382, 383]
        },
        {
          name: "\u6613\u7136",
          staff_id: 881,
          all_types: [10, 8, 9, 11],
          email: "",
          types: [],
          all_ids: [881, 882, 883, 884]
        },
        {
          name: "\u66f9\u5b50\u5bd2",
          staff_id: 25,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [25]
        },
        {
          name: "\u66f9\u6587\u6d69",
          staff_id: 553,
          all_types: [10, 8, 9],
          email: "",
          types: [],
          all_ids: [553, 554, 555]
        },
        {
          name: "\u6731\u519b",
          staff_id: 208,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [208, 248, 249]
        },
        {
          name: "\u6731\u5b8f\u4fa0",
          staff_id: 24,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [24]
        },
        {
          name: "\u6731\u61ff\u5a77",
          staff_id: 203,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [203, 250, 251]
        },
        {
          name: "\u6731\u745e\u740e",
          staff_id: 629,
          all_types: [8, 9],
          email: "",
          types: [],
          all_ids: [629, 630]
        },
        {
          name: "\u6731\u7476",
          staff_id: 514,
          all_types: [9, 11],
          email: "",
          types: [],
          all_ids: [514, 515]
        },
        {
          name: "\u674e\u4f73\u5fc6",
          staff_id: 454,
          all_types: [4, 3, 5, 9, 10],
          email: "",
          types: [],
          all_ids: [454, 477, 478, 529, 534]
        },
        {
          name: "\u674e\u4fca\u96c5",
          staff_id: 26,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [26]
        },
        {
          name: "\u674e\u5531\u5531",
          staff_id: 204,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [204, 252, 253]
        },
        {
          name: "\u674e\u6587\u96c5",
          staff_id: 642,
          all_types: [1, 12, 4],
          email: "",
          types: [],
          all_ids: [642, 643, 645]
        },
        {
          name: "\u674e\u6606\u9f99",
          staff_id: 473,
          all_types: [2, 6, 10, 4],
          email: "",
          types: [],
          all_ids: [473, 474, 475, 476]
        },
        {
          name: "\u674e\u68a6\u8f89",
          staff_id: 603,
          all_types: [1, 7, 6],
          email: "",
          types: [],
          all_ids: [603, 604, 605]
        },
        {
          name: "\u674e\u6b63\u9633",
          staff_id: 812,
          all_types: [10, 9, 8],
          email: "",
          types: [],
          all_ids: [812, 813, 814]
        },
        {
          name: "\u674e\u745e",
          staff_id: 698,
          all_types: [4, 9, 5, 3],
          email: "",
          types: [],
          all_ids: [698, 729, 757, 758]
        },
        {
          name: "\u674e\u79cb\u4e91",
          staff_id: 11,
          all_types: [3, 4, 8],
          email: "",
          types: [],
          all_ids: [11, 69, 101]
        },
        {
          name: "\u674e\u7d20\u5a77",
          staff_id: 910,
          all_types: [2, 9, 10],
          email: "sutin.li@miicore.com",
          types: [],
          all_ids: [910, 911, 912]
        },
        {
          name: "\u675c\u5a1f",
          staff_id: 654,
          all_types: [4, 9, 8, 10],
          email: "",
          types: [],
          all_ids: [654, 655, 656, 657]
        },
        {
          name: "\u6768\u4ed5\u6770",
          staff_id: 570,
          all_types: [1, 12, 7, 9, 6],
          email: "",
          types: [],
          all_ids: [570, 571, 572, 573, 574]
        },
        {
          name: "\u6768\u5218",
          staff_id: 470,
          all_types: [2, 6, 10],
          email: "",
          types: [],
          all_ids: [470, 471, 472]
        },
        {
          name: "\u6768\u7490\u5a55",
          staff_id: 799,
          all_types: [9, 8, 10],
          email: "",
          types: [],
          all_ids: [799, 800, 801]
        },
        {
          name: "\u6768\u96ea\u6668",
          staff_id: 34,
          all_types: [2, 8, 10, 4, 9],
          email: "",
          types: [],
          all_ids: [34, 258, 259, 260, 261]
        },
        {
          name: "\u6768\u96ea\u6668AE",
          staff_id: 41,
          all_types: [4, 5, 6, 3, 8, 10, 9],
          email: "",
          types: [],
          all_ids: [41, 137, 138, 139, 143, 262, 263]
        },
        {
          name: "\u6797\u4f73\u6b23\uff08\u4e2d\u7ea7\uff09",
          staff_id: 150,
          all_types: [1, 7],
          email: "",
          types: [],
          all_ids: [150, 264]
        },
        {
          name: "\u67e5\u6587\u94a6",
          staff_id: 122,
          all_types: [4, 3, 5, 10, 9],
          email: "",
          types: [],
          all_ids: [122, 123, 124, 265, 266]
        },
        {
          name: "\u67f4\u6c38\u8d85",
          staff_id: 144,
          all_types: [2, 10, 6],
          email: "",
          types: [],
          all_ids: [144, 153, 267]
        },
        {
          name: "\u6c64\u5955\u84c9",
          staff_id: 493,
          all_types: [3, 10, 8, 9, 4, 5, 6],
          email: "",
          types: [],
          all_ids: [493, 494, 495, 496, 497, 498, 499]
        },
        {
          name: "\u6c88\u4e39\uff08\u4e2d\u7ea7\uff09",
          staff_id: 119,
          all_types: [7, 1],
          email: "",
          types: [],
          all_ids: [119, 180]
        },
        {
          name: "\u6c88\u5a34",
          staff_id: 29,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [29]
        },
        {
          name: "\u6c88\u8d3a",
          staff_id: 886,
          all_types: [7, 1, 12],
          email: "shenhe@miicore.com",
          types: [],
          all_ids: [886, 887, 888]
        },
        {
          name: "\u6c88\u8d5f",
          staff_id: 563,
          all_types: [4, 9, 10],
          email: "shenyun@miicore.com",
          types: [],
          all_ids: [563, 564, 565]
        },
        {
          name: "\u725b\u6d77\u971e",
          staff_id: 52,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [52]
        },
        {
          name: "\u738b\u4f73\u946b",
          staff_id: 402,
          all_types: [4, 9, 10, 5, 3],
          email: "",
          types: [],
          all_ids: [402, 403, 404, 617, 618]
        },
        {
          name: "\u738b\u51b0\u83b9",
          staff_id: 355,
          all_types: [5, 3, 10, 9, 4],
          email: "",
          types: [],
          all_ids: [355, 356, 357, 358, 359]
        },
        {
          name: "\u738b\u51ef\u96c4",
          staff_id: 455,
          all_types: [4, 9],
          email: "",
          types: [],
          all_ids: [455, 456]
        },
        {
          name: "\u738b\u5353",
          staff_id: 8,
          all_types: [2, 6, 10],
          email: "",
          types: [],
          all_ids: [8, 106, 169]
        },
        {
          name: "\u738b\u6021\u6e49",
          staff_id: 140,
          all_types: [8, 9, 10],
          email: "",
          types: [],
          all_ids: [140, 141, 142]
        },
        {
          name: "\u738b\u660e\u7389",
          staff_id: 33,
          all_types: [2],
          email: "",
          types: [],
          all_ids: [33]
        },
        {
          name: "\u738b\u6668\u6668",
          staff_id: 751,
          all_types: [10, 8, 11, 9],
          email: "",
          types: [],
          all_ids: [751, 752, 753, 754]
        },
        {
          name: "\u738b\u8273\u840c",
          staff_id: 5,
          all_types: [2],
          email: "",
          types: [],
          all_ids: [5]
        },
        {
          name: "\u738b\u8273\u840cAE\u53f7",
          staff_id: 46,
          all_types: [4, 6, 5, 3, 10, 9],
          email: "",
          types: [],
          all_ids: [46, 107, 108, 136, 273, 274]
        },
        {
          name: "\u7530\u5b87",
          staff_id: 56,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [56]
        },
        {
          name: "\u7530\u6653\u9e4f",
          staff_id: 367,
          all_types: [7, 1],
          email: "",
          types: [],
          all_ids: [367, 368]
        },
        {
          name: "\u7530\u6653\u9e4f\uff08\u4e2d\u7ea7\uff09",
          staff_id: 380,
          all_types: [1, 7],
          email: "",
          types: [],
          all_ids: [380, 381]
        },
        {
          name: "\u7533\u5a77",
          staff_id: 852,
          all_types: [9, 10, 8, 11],
          email: "tin.shen@miicore.com",
          types: [],
          all_ids: [852, 853, 854, 918]
        },
        {
          name: "\u77f3\u68a6\u68a6",
          staff_id: 9,
          all_types: [2],
          email: "",
          types: [],
          all_ids: [9]
        },
        {
          name: "\u7a0b\u7389\u7433",
          staff_id: 19,
          all_types: [3, 4, 5],
          email: "",
          types: [],
          all_ids: [19, 109, 110]
        },
        {
          name: "\u7a0b\u831c",
          staff_id: 31,
          all_types: [3, 4, 9, 10],
          email: "",
          types: [],
          all_ids: [31, 436, 437, 438]
        },
        {
          name: "\u7f57\u5174\u5176",
          staff_id: 120,
          all_types: [7],
          email: "",
          types: [],
          all_ids: [120]
        },
        {
          name: "\u7fc1\u5343\u6def",
          staff_id: 890,
          all_types: [4, 10, 11, 8, 9, 5, 3],
          email: "elainew@miicore.com",
          types: [],
          all_ids: [890, 891, 892, 893, 894, 916, 917]
        },
        {
          name: "\u8212\u5c55",
          staff_id: 575,
          all_types: [4, 3],
          email: "",
          types: [],
          all_ids: [575, 579]
        },
        {
          name: "\u82d7\u7490\u7490",
          staff_id: 51,
          all_types: [4, 3, 5, 8, 10, 9],
          email: "",
          types: [],
          all_ids: [51, 151, 152, 174, 280, 281]
        },
        {
          name: "\u8303\u4f73\u5b81",
          staff_id: 414,
          all_types: [2, 6, 10],
          email: "",
          types: [],
          all_ids: [414, 415, 450]
        },
        {
          name: "\u8303\u7ea2\u6885",
          staff_id: 189,
          all_types: [8, 10, 9, 4],
          email: "",
          types: [],
          all_ids: [189, 282, 283, 452]
        },
        {
          name: "\u845b\u799b\u4fca",
          staff_id: 310,
          all_types: [3, 5, 8],
          email: "",
          types: [],
          all_ids: [310, 311, 392]
        },
        {
          name: "\u848b\u51cc\u6beb",
          staff_id: 684,
          all_types: [1, 12],
          email: "",
          types: [],
          all_ids: [684, 685]
        },
        {
          name: "\u848b\u8389\u8389",
          staff_id: 426,
          all_types: [2, 6],
          email: "",
          types: [],
          all_ids: [426, 427]
        },
        {
          name: "\u8521\u5fe0\u5cad17010008",
          staff_id: 73,
          all_types: [4, 6, 5, 9, 10, 8, 3, 7],
          email: "",
          types: [],
          all_ids: [73, 78, 113, 160, 178, 451, 562, 633]
        },
        {
          name: "\u88f4\u4e66\u7434",
          staff_id: 536,
          all_types: [4, 9],
          email: "",
          types: [],
          all_ids: [536, 537]
        },
        {
          name: "\u8c22\u6b23",
          staff_id: 23,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [23]
        },
        {
          name: "\u8c2d\u65fb\u6708",
          staff_id: 467,
          all_types: [2, 9, 6],
          email: "",
          types: [],
          all_ids: [467, 468, 469]
        },
        {
          name: "\u8c2d\u7167\u4e91",
          staff_id: 397,
          all_types: [9],
          email: "",
          types: [],
          all_ids: [397]
        },
        {
          name: "\u8d3e\u777f\u7487",
          staff_id: 127,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [127]
        },
        {
          name: "\u8d75\u4f73\u742a",
          staff_id: 484,
          all_types: [4, 9, 8, 2],
          email: "",
          types: [],
          all_ids: [484, 485, 486, 528]
        },
        {
          name: "\u8d75\u9e4f\u5a9b",
          staff_id: 207,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [207, 291, 292]
        },
        {
          name: "\u9093\u6155\u60a0",
          staff_id: 190,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [190, 293, 294]
        },
        {
          name: "\u90b1\u51c0\u6d01",
          staff_id: 181,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [181, 182, 183]
        },
        {
          name: "\u90dd\u5bb6\u8f89",
          staff_id: 895,
          all_types: [9, 8, 10],
          email: "jiahui.hao@miicore.com",
          types: [],
          all_ids: [895, 896, 897]
        },
        {
          name: "\u90ed\u5609\u51ef",
          staff_id: 697,
          all_types: [4],
          email: "",
          types: [],
          all_ids: [697]
        },
        {
          name: "\u90ed\u5b97\u4f1f",
          staff_id: 623,
          all_types: [9, 8, 4],
          email: "",
          types: [],
          all_ids: [623, 679, 680]
        },
        {
          name: "\u962e\u8bd7",
          staff_id: 28,
          all_types: [3, 4],
          email: "",
          types: [],
          all_ids: [28, 126]
        },
        {
          name: "\u9648\u601d\u6768",
          staff_id: 416,
          all_types: [4, 8, 9, 10],
          email: "",
          types: [],
          all_ids: [416, 417, 418, 419]
        },
        {
          name: "\u9648\u6d01",
          staff_id: 195,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [195, 299, 300]
        },
        {
          name: "\u9648\u8389\u8389",
          staff_id: 27,
          all_types: [3, 4],
          email: "",
          types: [],
          all_ids: [27, 50]
        },
        {
          name: "\u97e9\u4f73\u96ef",
          staff_id: 45,
          all_types: [4, 9, 3, 5],
          email: "",
          types: [],
          all_ids: [45, 177, 301, 302]
        },
        {
          name: "\u987e\u601d\u749f",
          staff_id: 524,
          all_types: [2, 10, 6],
          email: "",
          types: [],
          all_ids: [524, 525, 526]
        },
        {
          name: "\u987e\u6587\u864e",
          staff_id: 339,
          all_types: [10, 3, 5, 4, 9, 8],
          email: "",
          types: [],
          all_ids: [339, 340, 341, 342, 343, 364]
        },
        {
          name: "\u987e\u6d69",
          staff_id: 490,
          all_types: [8, 9, 10],
          email: "",
          types: [],
          all_ids: [490, 491, 492]
        },
        {
          name: "\u9a6c\u5343\u8559",
          staff_id: 662,
          all_types: [9, 8, 10],
          email: "",
          types: [],
          all_ids: [662, 663, 664]
        },
        {
          name: "\u9ad8\u5b5f\u9633",
          staff_id: 420,
          all_types: [4, 9, 10],
          email: "",
          types: [],
          all_ids: [420, 421, 422]
        },
        {
          name: "\u9ad8\u68a6\u831c",
          staff_id: 907,
          all_types: [1, 12],
          email: "mengxi@miicore.com",
          types: [],
          all_ids: [907, 908]
        },
        {
          name: "\u9ec4\u514b",
          staff_id: 681,
          all_types: [8, 9, 10],
          email: "",
          types: [],
          all_ids: [681, 682, 683]
        },
        {
          name: "\u9ec4\u5fd7\u4f1f",
          staff_id: 764,
          all_types: [8, 10, 9],
          email: "",
          types: [],
          all_ids: [764, 765, 766]
        },
        {
          name: "\u9ec4\u61ff",
          staff_id: 767,
          all_types: [8, 4, 9, 10],
          email: "",
          types: [],
          all_ids: [767, 768, 769, 770]
        },
        {
          name: "\u9f9a\u5706\u6995",
          staff_id: 624,
          all_types: [4, 9, 10],
          email: "",
          types: [],
          all_ids: [624, 625, 626]
        },
        {
          name: "\u9f9a\u5929\u5c0a",
          staff_id: 21,
          all_types: [3],
          email: "",
          types: [],
          all_ids: [21]
        },
        {
          name: "\u9f9a\u5e86",
          staff_id: 428,
          all_types: [9, 8],
          email: "",
          types: [],
          all_ids: [428, 429]
        },
        {
          name: "\u9f9a\u715c",
          staff_id: 401,
          all_types: [7],
          email: "",
          types: [],
          all_ids: [401]
        }
      ]
    },
    msg: "succ"
  }
};



// WEBPACK FOOTER //
// ./src/common/common.js